import React from 'react';
import ReactDOM from 'react-dom';
import Cookies from 'universal-cookie';
import Responsive from 'react-responsive';
import xss from 'xss';
import loadjs from 'loadjs';
import parse from 'html-react-parser';
import { RadioBox } from '@vds/radio-boxes';
import { call } from 'redux-saga/effects';
import styled from 'styled-components';
import { isIOSNewVersion } from './util';
import { getItemFromStore } from '../../../utils/sessionStorage';
import { store } from '../../../configureStore';
import { preFetchConsts, cradleThrottleValues, wifiPlanIds, wifiTransactionType, appleOnePriceUpIds, MOVERS_PLAN_TYPE, VHI_LITE_PLAN_NAME, VHI_LITE_PLAN_ID, DYNAMIC_DISCOUNT_VALUE, VHI_LITE_EXTRA_PLAN_ID, JT_PROCESSING_MTN_KEY, DEFAULT_PROCESSING_MTN, VALID_LINE_PARAM_PATTERN } from './constants';
import { getQueryParamByName } from './queryParams';
import { VISION_FEATURE_CODE } from '../MiniCart/Constants';
import { pageList } from './processStepData';
import { FWA_PLANS, THUNDER_WHW_PRODUCTIDS, WIFI_BACKUP } from '../../../pages/Common/SessionValues/Constants';
import { getMoversFlowValues, getResumeFlow, getRetryFlowValues, getSequentialFlowValues, getWholeHomeWifiFlow, getFlowTypeValue, getOtgFlow, getWifiBackupFlow } from './flowTypeUtils';
import { CRITICAL, HIGH } from '../../Web/DeviceSetup/constants';
import { STREAM_TV_PRODUCT_ID } from '../../Web/Cart/redesign/Components/constant';

export const formatRouterName = (item) => {
  let planName = item?.name || item?.description || '';
  const sorId = item?.sorId;
  if (sorId && planName?.includes(sorId)) {
    planName = planName?.replace(sorId, '')?.trim();
  }
  return planName;
};

export const getRouterUpgradeDiscount = (cartTotalDiscounts) => {
  if (!isTRUPFlow() || !cartTotalDiscounts?.discountDetails?.length) {
    return null;
  }
  for (const discountDetail of cartTotalDiscounts.discountDetails) {
    const found = (discountDetail?.discountItems || []).find(
      (item) => item?.discountName === 'Router Upgrade Discount',
    );
    if (found) {
      return { desc: found.discountName, amount: discountDetail.totalMonthlyDiscount };
    }
  }
  return null;
};

export const isWHW = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  if (getSession('WHW') === 'true' || params.has('whwf_redeem')) {
    return true;
  }
  return false;
};

export const isTRUPFlow = () => getSession('isFwaTrupUpgradeEligible') === 'true';

export const enableLiveFun = () => !(isWHW() || isWHWP2());
export const isWifiBackupPlan = (checkPlan) => wifiPlanIds.includes(checkPlan.pricePlanCode);
export const isWHWP2 = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const whwFlag = viewport() === 'mfapp' ? getCookie('WHWP2') : getSession('WHWP2');
  if (whwFlag === 'Y' || params.has('whwp_redeem')) {
    return true;
  }
  return false;
};

export const getAMURL = (plansReferenceData) => {
  const hostName = window.location.hostname;
  let APIContext = '';
  if (hostName.indexOf('.verizonwireless.com') > -1) {
    const qaEnv = window.location.host.split('.');
    const lowerEnv = qaEnv?.[0]?.slice(-3);
    const number = lowerEnv?.match(/(\d+)/);
    if (number?.[0] > 9) {
      APIContext = `https://accessmgrqa${number[0]}.verizonwireless.com/vzauth/UI/Login?realm=vzw&goto=https://vzwqa${number[0]}.verizonwireless.com/sales/home/expresscart.html?expresscart=true%26signinfromCredit%3dtrue&userNameOnly=false&rememberUserNameCheckBoxExists=Y&offerShortLivedPassword=Y&mode=o`;
    } else {
      APIContext = `https://securesit${number?.[0]}.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https%3A%2F%2Fvzwqa${number?.[0]}.verizonwireless.com%2Fsales%2Fhome%2Fexpresscart.html%3Fexpresscart%3Dtrue%26signinfromCredit%3dtrue`;
    }
  } else {
    APIContext =
      plansReferenceData?.signInProdNSAUrl ||
      'https://secure.verizon.com/signin?mode=i&userNameOnly=true&clientId=VZCOMBQ&goto=https://www.verizon.com/sales/home/expresscart.html?expresscart=true%26signinfromCredit%3dtrue';
  }
  return `${APIContext}`;
};

export const getLqDetails = () => {
  const qualificationResponse = getSession('qualificationResponse') || null;
  const qualificationResponseData = qualificationResponse ? JSON.parse(qualificationResponse) : {};
  return qualificationResponseData;
};

export const checkPriceGuaranteeFFlag = () => getSession('priceGuaranteeFFlag') === 'true' || false;

export const isUpsellModalApplied = () => getSession('upsellModalApplied') === 'true' || false;

export const saveTheSaleOfferApplied = () => getSession('saveTheSaleOfferApplied') === 'Y' || false;

export const upsellOfferApplied = () => getSession('upsellOfferApplied') === 'Y' || false;

export const isLteOnlyQualified = () => {
  const LQResponseData = getSession('LQResponse');
  const networkBandwidthType = LQResponseData ? JSON.parse(LQResponseData)?.output?.networkBandwidthType : '';
  return networkBandwidthType?.toUpperCase() === 'LTE';
};

/**
 * this method is used to check the plans if there are more plans,
 * we will show edit button to edit the plan otherwise will not show the edit button.
 * @returns boolean true or false
 */
export const checkEditPlanStatus = () => {
  const qualificationResponseData = getLqDetails();
  const {
    qualifiedCBand = false,
    qualified4GHome = false,
    wifiBackupCbandQualified = false,
    wifiBackupLteQualified = false,
    qualified = false,
    qualifiedLte = false,
    VHILiteQualified = false,
  } = qualificationResponseData;
  
  const hasWifiBackupQualification = wifiBackupCbandQualified || wifiBackupLteQualified;
  const hasOtherQualifiedProducts = qualifiedCBand || qualified4GHome || qualifiedLte || qualified || VHILiteQualified;
  
  if (hasWifiBackupQualification && !hasOtherQualifiedProducts) {
    return false;
  }
  
  return true;
};

/**
 * used to check selected plan is wifi or not.
 * @param {selected plan} id
 * @returns boolean true or false
 */
export const checkSelectedPlanIsWifi = (dueMonthly) => {
  let selectedPlan = [];
  if (dueMonthly && dueMonthly.length) {
    selectedPlan = dueMonthly.filter((item) => item?.itemType === 'PLAN');
  }
  return wifiPlanIds?.includes(selectedPlan?.[0]?.productId || '');
};

export const checkIsWifiBackupPlan = () => {
  const { progressivePlans = {} } = store.getState();
  const selectedPlanId = progressivePlans?.selectedPlanInfo?.selectedPlan?.planId || '';
  return wifiPlanIds?.includes(selectedPlanId.toString() || '');
};

export const checkisCBandStalledFlag = () => {
  const selectedPlanId = store.getState()?.progressivePlans?.cbandStall || false;
  return selectedPlanId;
};

/**
 *  used to check bundle installation type on the basis of flow.
 * @param {type} type
 * @returns bundle winstallation type
 */
export const bundleInstallType = (type) => {
  let installType = '';
  const qualificationResponseData = getLqDetails();
  const { bundleDetails = [], wifiBackupBundle = [] } = qualificationResponseData;
  if (type === 'wifi') {
    installType = wifiBackupBundle && wifiBackupBundle?.length > 0 ? wifiBackupBundle[0]?.bundleName : '';
  } else {
    installType = bundleDetails && bundleDetails?.length > 0 ? bundleDetails[0]?.bundleName : '';
  }
  return installType;
};

export const isWHWUpgradeOnly = () => {
  const { whwUpgradeOnly } = window.vzFlags || {};
  return whwUpgradeOnly || getSession('whwUpgradeOnly') === 'Y';
};

export const getIntendTypeVal = (intendTypeval) => {
  let intendTypevalue = intendTypeval;
  if (isWWM() || isTitanOneUpgradeFlag()) {
    intendTypevalue = 'EUP_5G';
  }
  return intendTypevalue;
};

export const getIntendType = (pageName) => {
  let intendTypeval = '';
  const FlowType = getSession('FlowType');
  if (getSession('isCBandQual') === 'Y') {
    if (getLTEUpgrade()) {
      intendTypeval = '4GLTEUpgrade';
    } else if (isMoversFlow()) {
      intendTypeval = 'movers';
    } else {
      if (getAPPID() === 'AAL') intendTypeval = 'AAL_5G';
      else {
        intendTypeval = 'NSE_5G';
      }
      if (pageName && pageName === 'payment') {
        if (intendTypeval === 'AAL_5G' || intendTypeval === 'AAL_LTE') {
          intendTypeval = 'AAL';
        } else if (intendTypeval === 'NSE_5G' || intendTypeval === 'NSE_LTE') {
          intendTypeval = 'NSE';
        }
      }
    }
  } else if (getLTEUpgrade()) {
    intendTypeval = '4GLTEUpgrade';
  } else if (isMoversFlow()) {
    intendTypeval = 'movers';
  } else if (isWHW() || isWHWP2()) intendTypeval = 'ACC';
  else if (isDeviceUpgradeFlow()) intendTypeval = 'EXC';
  else if (getAPPID() === 'AAL' && FlowType && FlowType === '5G') intendTypeval = 'AAL_5G';
  else if (getAPPID() === 'AAL' && FlowType && FlowType === 'LTE') intendTypeval = 'AAL_LTE';
  else if (FlowType && FlowType === '5G') intendTypeval = 'NSE_5G';
  else if (FlowType && FlowType === 'LTE') intendTypeval = 'NSE_LTE';
  else if (pageName && pageName === 'payment') {
    if (intendTypeval === 'AAL_5G' || intendTypeval === 'AAL_LTE') {
      intendTypeval = 'AAL';
    } else if (intendTypeval === 'NSE_5G' || intendTypeval === 'NSE_LTE') {
      intendTypeval = 'NSE';
    }
  }
  intendTypeval = getIntendTypeVal(intendTypeval);
  return intendTypeval;
};

export const getClientSpecificInformationFromUserAgent = () => {
  const osSpecificInfoResultMap = {};
  try {
    if (window.navigator.userAgent.indexOf('MY_VZW_APP/') > -1 && window.navigator.userAgent.lastIndexOf(')') > -1) {
      const userAgentString = window?.navigator?.userAgent?.substring(window?.navigator?.userAgent?.indexOf('MY_VZW_APP/'));
      const osSpecificInfo = userAgentString?.substring(userAgentString.indexOf('(') + 1, userAgentString.lastIndexOf(')'));
      if (osSpecificInfo) {
        const resultList = osSpecificInfo.split(';');
        if (resultList && resultList.length > 0) {
          for (const k of resultList) {
            osSpecificInfoResultMap[k.split(':')[0].trim()] = k.split(':')[1].trim();
          }
        }
      }

      // clientAppVersion.
      const clientAppVersionString = userAgentString.split('/')[1];
      if (clientAppVersionString && clientAppVersionString?.split('(')?.length > 0) {
        const result = clientAppVersionString.split('(')[0] ? clientAppVersionString.split('(')[0] : '';
        osSpecificInfoResultMap.clientAppVersion = result?.trim();
      }
    }
    return osSpecificInfoResultMap;
  } catch (error) {
    console.log(error);
  }
  return osSpecificInfoResultMap;
};

export const getFlowTypeWithIntend = (type = '') => {
  let val = '';
  if (getSession('CustTab') === null) {
    const timeformat = Date.now();
    setSession('CustTab', timeformat);
  }
  const FlowType = getSession('FlowType');
  const isResumeAbandoned = getItemFromStore('isResumeAbandoned');
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const isTGWFlow = getSession('isTGW');
  const isLoggedIn = getAPPID() === 'AAL';
  val = getFlowTypeValue(FlowType, isTGWFlow, isLoggedIn);

  if (type === wifiTransactionType) {
    const qualificationResponseData = getLqDetails();
    const { wifiBackupCbandQualified = false } = qualificationResponseData;
    val = getWifiBackupFlow(isLoggedIn, wifiBackupCbandQualified)
  }

  val = getOtgFlow(val, params);
  val = getResumeFlow(val);

  if (isWHW() || isWHWP2()) {
    val = 'WHW_Redemption';
  }

  const { cartDetails, getCheckOutDetailsState } = store.getState();
  if (isPreorder() || cartDetails?.isPreorder) {
    val += '|PREORDER';
  }

  val = getWholeHomeWifiFlow(
    val,
    cartDetails?.cartDetailsJson?.dueTodayList,
    cartDetails?.cartDetailsJson?.dueMonthlyList,
    getCheckOutDetailsState?.lineDetails?.lineInfo?.newLine1?.serviceInfo?.selectedFeaturesList?.visFeature,
  );

  if (isResumeAbandoned && getAPPID() === 'NSE') {
    val += '|AbCart';
  }

  val = getRetryFlowValues(val);
  val = getMoversFlowValues(val, isLoggedIn, FlowType);
  val = getSequentialFlowValues(val, getSeqFlowType());

  if (isWWM() && !isTitanOneUpgradeFlag()) {
    val = 'WWM_Redemption';
  }
  return val;
};

export const getFlowType = () => {
  const isWHWFlag = isWHWP2() || isWHW();
  const flowType = isWHWFlag && viewport() === 'mfapp' ? getCookie('FlowType') : getSession('FlowType');
  return flowType;
};

export const getCookie = (name) => {
  let cookies;
  if (window.vzFlags?.enableCookieKeys) {
    if (window.CookieKeys?.get(name)) {
      cookies = window.CookieKeys;
    } else {
      window.CookieKeys = document.cookie?.split(';')?.reduce((a, c) => a.set(c?.split('=')?.[0]?.trim(), c?.split('=')?.[1]?.trim()), new Map());
      cookies = window.CookieKeys;
    }
  } else {
    cookies = new Cookies();
  }
  if (window.vzFlags?.processGuestRoleCustomer && name === 'loggedIn' && cookies.get(name) && cookies.get('role')) {
    return cookies.get('role') !== 'guest' ? 'true' : '';
  }
  const cookieValue = cookies.get(name) || '';
  if (cookieValue !== '') {
    return decodeURIComponent(cookieValue);
  }
  return cookieValue;
};

export const setCookie = (cookieName, value) => {
  document.cookie = `${xss(cookieName)}=${xss(encodeURIComponent(value))};path=/`;
  if (window.vzFlags?.enableCookieKeys) {
    window.CookieKeys = document.cookie?.split(';')?.reduce((a, c) => a.set(c?.split('=')?.[0]?.trim(), c?.split('=')?.[1]?.trim()), new Map());
  }
};

export const getCookieHelper = (name) => {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  if (match) return match[2];
  return null;
};

const handleValue = (cookieValue, name) => {
  if (cookieValue !== null) return cookieValue;
  const cookieNames = [
    'LQResponse',
    'FlowType',
    'isCBandQual',
    'cartExist',
    'Fwa_MN',
    'barCodeId',
    'fwaProspectExpressCheckout',
  ];
  return cookieNames.includes(name) ? getCookieHelper(name) : cookieValue;
};

export const getSession = (name) => {
  let value;
  if (window.vzFlags?.localStorage === true || sessionStorage.getItem('enableLocalStorage') === 'true') {
    value = window.localStorage.getItem(name);
  } else {
    value = window.sessionStorage.getItem(name);
  }
  value = handleValue(value, name);
  return value;
};

export const getFFlagsOnMount = (propName) => {
  const vpmFeatureFlags = getSession('vpmFeatureFlags');
  if (!vpmFeatureFlags) return false;

  try {
    const featureFlags = JSON.parse(vpmFeatureFlags);
    if (!featureFlags) return false;

    const propValue = featureFlags[propName];
    return propValue === true || propValue === 'true' || propValue === 'TRUE';
  } catch (error) {
    console.error('Error parsing vpmFeatureFlags from session storage:', error);
    return false;
  }
};

export const setSession = (sessionName, value) => {
  if (window.vzFlags?.localStorage || sessionStorage.getItem('enableLocalStorage') === 'true') {
    window.localStorage.setItem(sessionName, value);
  } else {
    window.sessionStorage.setItem(sessionName, value);
  }
};

export const removeSessionItem = (sessionName) => {
  if (window.vzFlags?.localStorage || sessionStorage.getItem('enableLocalStorage') === 'true') {
    window.localStorage.removeItem(sessionName);
  } else {
    window.sessionStorage.removeItem(sessionName);
  }
};

export const getColorTheme = () => {
  let theme;
  let cookieCondition = false;
  let variantEnabled = false;
  if (
    window.location.href.indexOf('vzwqa') > 0 ||
    window.location.href.indexOf('localhost') > 0 ||
    window.location.href.indexOf('nssit5') > 0 ||
    window.vzFlags.isProd === 'false' ||
    window.vzFlags.isProd === false
  ) {
    cookieCondition = getCookie('Monarch_Enabled') === 'true' || getCookie('Monarch_Enabled') === true;
  } else if (window.location.href.indexOf('www.verizon.com') > 0 || window.vzFlags.isProd === true || window.vzFlags.isProd === 'true') {
    cookieCondition = true;
  }

  if (isMVA() || (isMVA() && variantEnabled)) {
    const { clientAppVersion = '0' } = getClientSpecificInformationFromUserAgent() || {};
    variantEnabled = Math.floor(clientAppVersion.split('.')[0]) >= 20 && cookieCondition;
  } else {
    variantEnabled = cookieCondition;
  }

  if (window.vzFlags?.colorTheme !== '') {
    theme = window.vzFlags?.colorTheme;
  } else {
    theme = '';
  }

  return theme;
};

const isMoversMLP = () => ['moversMainLanding.html', '/home/move'].some((path) => window.location.href?.includes(path));

export const isMoversFlow = () => {
  let moversFlow = false;
  const AAL = getAPPID() === 'AAL';
  if (AAL) {
    const moversSession = getSession('isMovers') || window.location.href?.indexOf('movers') > -1;
    const moversCookie = getCookie('isMovers') && getCookie('isMovers') !== false ? getCookie('isMovers') : false;
    moversFlow = isMoversMLP() || !!(moversCookie && moversSession);
  }
  return moversFlow;
};
export const isRetailFlow = () => {
  let retailFlow = false;

  if (window.location.href.indexOf('retail') > -1) retailFlow = true;

  return retailFlow;
};

export const isCPCCheckAvailabilityFlow = () => {
  let addressQual = false;
  if (window.location.href.indexOf('cpcCheckAvailability') > -1) addressQual = true;
  return addressQual;
};

export const isComboFlow = () => window.location.href.indexOf('combo') > -1;

export const isExternalFlow = () => window.location.href.indexOf('external') > -1;
export const isBroadBandFlow = () => getCookie('site') === 'InternalFlow' || getCookie('site') === 'NRFlow' || getSession('fcc') === 'true';

export const isGlobalHeader = () =>
  getCookie('site') === 'InternalFlow' || getCookie('site') === 'NRFlow' || window.location.href.indexOf('broadBandFacts') > -1;

export const isOCOFlow = () => {
  const ocoFlow = getCookie('OCOFlow') ? getCookie('OCOFlow') : 'false';
  return ocoFlow;
};

export const getServiceUrlandE2eRequestId = (method, response = null) => {
  let e2eid = response?.headers?.e2erequestid || '';
  if (!e2eid && response?.headers) {
    const e2eHeaderKey = Object.keys(response.headers).find((item) => item?.toLowerCase() === 'e2erequestid');
    if (e2eHeaderKey) {
      e2eid = response.headers[e2eHeaderKey];
    }
  }
  let serviceUrl;
  if (response) {
    // If serviceUrl is provided then always log the service that matches that
    serviceUrl = response?.config?.url;
  }
  return { method, e2eid, serviceUrl };
};

export const getPageName = () => {
  const name = getUrlName(window.location.href);

  const pageNameMap = {
    plansOverview: 'plansoverview',
    plans: 'homePlanDetails',
    addons: 'getStreamingDevices',
    WestworldUpgrade: 'WestworldUpgrade',
    DeviceUpgrade: 'DeviceUpgrade',
    setup: 'deviceSetup',
    cart: 'getCartDetails',
    contactinfo: 'getContactInfo',
    payment: 'getCustomerPaymentInfo',
    appointment: 'getAvailableInstallationDates',
    shipping: 'displayShippingOptions',
    creditstatus: 'creditstatus',
    confirmation: 'orderConfirmation',
    orderreview: 'reviewOrder',
    revieworder: 'revieworder',
    orderReview: 'orderReview',
    expresscart: 'expresscart',
    sendlink: 'sendlink',
    landing: 'landing',
    registration: 'registration',
    techexpresscart: 'techexpresscart',
    addresslookup: 'addresslookup',
    broadBandFacts: 'broadBandFacts',
    addressSearch: 'addressSearch',
    'ext-addressSearch': 'ext-addressSearch',
    progressiveplan: 'progressiveplans',
    popularplan: 'popularplans',
    vfdiscount: 'vfdiscount',
    expresscheckout: 'expresscheckout',
    expresstos: 'expresstos',
    streamlineordering: 'progressiveplans streamlineordering',
    moversShipping: 'movers shipping',
    overview: 'movers overview',
    moversDeviceSetup: 'movers device setup',
    equipments: 'movers equipment',
    moversPayment: 'movers payment',
    createprofile: 'createprofile',
  };

  if (name === 'creditcheck') {
    const eidStatus = getSession('showEid');
    return eidStatus === 'true' ? 'EID' : 'creditCheck';
  }

  return pageNameMap[name] || '';
};

export const isMobile = () => {
  const mobilePattern = /Android|webOS|iPhone|BlackBerry|Windows Phone|MY_VZW_APP/i;
  return mobilePattern.test(navigator.userAgent);
};

export const isTablet = () => {
  if (window.innerWidth <= 1024 && window.innerWidth >= 768) {
    return true;
  }
  let userAgentString = window.navigator && window.navigator.userAgent;
  if (userAgentString) {
    userAgentString = userAgentString.toLowerCase();
    if (
      (userAgentString.includes('windows') && userAgentString.includes('touch')) ||
      userAgentString.includes('tablet') ||
      userAgentString.includes('ipad')
    ) {
      return true;
    }
  }

  return false;
};

// To check the resolution is similar to desktop which is above 1024
export const isDesktopResolution = () => window.innerWidth >= 1025;
export const isMobileResolution = () => window.innerWidth < 768;
export const isTabResolution = () => window.innerWidth < 900;

export const isIPad = () => {
  let userAgentString = window.navigator && window.navigator.userAgent;
  const vendor = window.navigator && window.navigator.vendor;

  if (window.innerWidth && window.innerWidth <= 1024 && window.innerWidth >= 768) {
    if (userAgentString && vendor && vendor !== 'Google Inc.') {
      userAgentString = userAgentString.toLowerCase();
      if (userAgentString.includes('ipad')) {
        return true;
      }

      return navigator.userAgent.match(/Mac/) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2;
    }
  }
  return false;
};

export const viewport = () => {
  let viewPort = '';
  if (isMVA()) {
    viewPort = 'mfapp';
  } else if (isMobile()) {
    viewPort = 'mobile';
  } else if (isTablet()) {
    viewPort = 'tablet';
  } else {
    viewPort = 'desktop';
  }
  return viewPort;
};

export const priceFormat = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat.replace('$', '').replace(/,/g, '').trim();
      return `$${parseFloat(price).toFixed(2)}`;
    }
    return '$0.00';
  }
  return '$0.00';
};

export const nonFloatingPrice = (data) => {
  if (data) {
    const dataFormat = data.toString();
    if (dataFormat.trim() && dataFormat.trim() !== '') {
      const price = dataFormat.replace('$', '').trim();
      return `$${parseFloat(price).toFixed(0)}`;
    }
    return '$0';
  }
  return '$0';
};

export const getParameterByName = (name) => {
  const url = window.location.href;
  const urlname = name.replace(/[[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${urlname}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  let result = '';
  if (urlname === 'navState') {
    result = results[2].replace('/', '');
  } else {
    result = results[2].replace(/\+/g, ' ');
  }
  return decodeURIComponent(result);
};

export const renderHTML = (data) => <span dangerouslySetInnerHTML={{ __html: data }} />;

export const renderHTMLBasic = (data) => <span dangerouslySetInnerHTML={{ __html: data }} />;

export const prepareNotificationTitle = (title) => {
  if (typeof title !== 'string') {
    return title;
  }

  const hasHtml = /<\/?[a-z][\s\S]*>/i.test(title);
  if (!hasHtml) {
    return title;
  }

  // Sanitize HTML first, then parse to React elements (no dangerouslySetInnerHTML)
  const sanitizedHtml = validateHTML(title);
  return parse(sanitizedHtml);
};

export const validateHTML = (str) => {
  if (str) {
    return xss(str, {
      onIgnoreTagAttr(tag, name, value) {
        if (name === 'id' || name === 'style') {
          return `${name}="${xss.escapeAttrValue(value)}"`;
        }
      },
    });
  }
  return '';
};

export const validateUrl = (str) => {
  if (str) {
    return str.replace(/</g, '<').replace(/>/g, '>');
  }
  return '';
};

export const isMVA = () => window.navigator.userAgent.indexOf('MY_VZW_APP') > -1;

export const iOSAPP = () => window.navigator.userAgent.indexOf('VZW-MFA-IOS') > -1;

export const androidAPP = () => window.navigator.userAgent.indexOf('VZW-MFA-ANDROID') > -1;

export const DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const getUrlName = (url) => {
  let items = url?.split('.html');
  if (items?.length > 0) {
    items = items[0].split('/');
    return items[items.length - 1];
  }
  return url;
};

export const songbirdScript = () =>
  window.vzFlags && window.vzFlags.isProd
    ? 'https://includes.ccdc02.com/cardinalcruise/v1/songbird.js'
    : 'https://includestest.ccdc02.com/cardinalcruise/v1/songbird.js';

export const googleMapScript = () =>
  'https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&client=gme-verizonwireless2&channel=vzw-desktop';

export const getApplePayMerchantIdentifier = () => (window.vzFlags && window.vzFlags.isProd ? 'merchant.com.vzw.MVM' : 'merchant.com.vzw.test');

export const getTimeDifferenceFromToday = (fromDate) => {
  const timeZone = 'EST';
  const counter = typeof window.duration !== 'undefined' ? window.duration : 0;
  const givenDate = new Date(`${fromDate.split('-').join('/')} ${timeZone}`).getTime();
  const formattedGivenDate = new Date(givenDate);
  const today = new Date();
  const msDiff = typeof window.duration !== 'undefined' ? counter : formattedGivenDate - today;
  return msDiff;
};

// to Identify Desktop, Mobile
export const Mobile = (props) => <Responsive {...props} maxWidth={512} />;

export const maskCard = (str) => str.substring(0, str.length - 4).replace(/./g, '0') + str.substring(str.length - 4, str.length);

export const getAPPID = () => {
  /** In Sequential Flow (Mobility Email to FWA) customer will be logged in with guest account.
   * In this scenario we will have loggedIn as true and role as guest in cookie.
   * We need to consider as NSE flow so added this MEC_FWA_NSE condition.
   */

  if (getSeqFlowType() !== 'MEC_FWA_NSE' && getCookie('loggedIn') === 'true') {
    // Check if role is guest & cookie is present - treat guest users as NSE
    if (getCookie('enableGuestAsProspect') === 'Y' && getCookie('role') === 'guest') {
      return 'NSE';
    }
    return 'AAL';
  }
  return 'NSE';
};

export const isGuestEnabled = () => getCookie('enableGuestAsProspect') === 'Y' && getCookie('loggedIn') === 'true' && getCookie('role') === 'guest';

export const isHeaderConsolidationEnabled = () => getCookie('enableHeaderConsolidation') === 'Y';

export const getLTEUpgrade = () => getSession('EUPUpgrade') === 'true';

export const isEUPFlow = () => {
  // const ocoFlow = getCookie('eUPFlow') && getCookie('eUPFlow') ? getCookie('eUPFlow') : 'false';
  const ocoFlow = window.location.href.indexOf('/eup/') > -1 || getCookie('eUPFlow') ? 'true' : 'false';
  return ocoFlow;
};
export const TechFlow = () => {
  const techFlow = window.location.href.indexOf('/tech/') > -1 || getCookie('techFlow') ? 'true' : 'false';
  return techFlow;
};
export const eagleCPCFlow = () => {
  const techFlow = window.location.href.indexOf('/cpc/') > -1 || getCookie('cpcFlow') ? 'true' : 'false';
  return techFlow;
};
export const whwTech = () => {
  const techFlow = window.location.href.indexOf('/whwTech/') > -1 || getCookie('whwTech') ? 'true' : 'false';
  return techFlow;
};
export const crossSiteCheckUrl = (str) => {
  if (str) {
    return xss(str);
  }
  return '';
};

export const pod2 = (number) => (number < 10 ? '0' : '') + number;

export const isAndroid = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const android = userAgent.indexOf('android') > -1;
  return android;
};

export const removeOneDuplicate = (arr, itemToRemove) => {
  const result = arr;
  const index = result.indexOf(itemToRemove);
  if (index > -1) {
    result.splice(index, 1);
  }
  return result;
};

function getDate(mm, dd, yyyy) {
  let month;
  let day;
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  if (mm && dd && yyyy) {
    day = Number(dd);
    month = Number(mm) - 1;
  } else {
    const today = new Date();
    day = today.getDate();
    month = today.getMonth();
  }
  if (day < 10) day = `0${day}`;
  return `${monthNames[month]} ${day}`;
}

export const convertDateRange = (dateRange) => {
  if (!dateRange) return null;
  const dates = dateRange.split('-');
  const len = dates.length - 1;
  let accumR;
  return dates.reduce((accum, date, index) => {
    const mm = date.split('/')[0];
    const dd = date.split('/')[1];
    const yyyy = date.split('/')[2];
    accumR = accum;
    if (index !== len) accumR += `${getDate(mm, dd, yyyy)} - `;
    else accumR += getDate(mm, dd, yyyy);
    return accumR;
  }, '');
};

export const isWholeHomeWifiIncluded = (detailsList = []) => {
  const matchingProduct = detailsList?.filter((i) => THUNDER_WHW_PRODUCTIDS.includes(i));
  return matchingProduct.length > 0;
};

export const getProcessStep = () => {
  const FlowType = getSession('FlowType');
  const isCBandQual = getSession('isCBandQual');
  const isCBandFlow = getSession('isCBandFlow');
  const LQResponseData = getSession('LQResponse');
  const bundleDetails = LQResponseData ? JSON.parse(LQResponseData)?.output?.bundleDetails : '';
  const bundleDetailsLength = bundleDetails && bundleDetails.length > 0;
  const iscbandPro = getSession('cbandPro');

  // Setup page wont be available
  if ((isCBandQual === 'Y' && isCBandFlow === 'Y' && FlowType === '5G' && !bundleDetailsLength && !iscbandPro) || FlowType === 'LTE') {
    return 'Accessories';
  }
  // Setup page will be available
  return 'InstallType';
};

export const isProfSetupAvailable = () => {
  const LQResponseData = getSession('LQResponse') || null;
  const bundleDetails = (LQResponseData && JSON.parse(LQResponseData)?.output?.bundleDetails) || [];
  if (bundleDetails?.length > 0) {
    const bundleName = bundleDetails?.map((i) => i?.bundleName?.toUpperCase());
    return bundleName?.some((i) => i?.includes('PRO'));
  }
  return false;
};

export const isPreorder = () => getSession('isPreorder') === 'true';

export const getBundleCategory = () => [];

export const dayAndMonth = (date) => {
  if (date) {
    const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const requiredDate = new Date(date);
    const day = days[requiredDate.getDay()];
    const dayDigit = requiredDate.getDate();
    const month = months[requiredDate.getMonth()];
    const formattedMonth = month && month.substring(0, 3);
    const requiredFormat = `${day}, ${formattedMonth} ${dayDigit}`;
    return requiredFormat;
  }
  return '';
};

export const isLoggedIn = () => getAPPID() === 'AAL';

export const getBrowserName = () => {
  const { userAgent } = navigator;
  let browserName;
  // ORDER MUST BE MAINTAINED
  if (userAgent && typeof userAgent === 'string') {
    if (userAgent.match(/(OPR|Opera)\/.*/i)) {
      // Has to be before Safari & Chrome
      browserName = 'Opera';
    } else if (userAgent.match(/Seamonkey\/.*/i)) {
      // Has to be before Firefox
      browserName = 'Seamonkey';
    } else if (userAgent.match(/Vivaldi\/.*/i)) {
      // Has to be before Chrome and Safari
      browserName = 'Vivaldi';
    } else if (userAgent.match(/YaBrowser\/.*/i)) {
      // Has to be before Chrome and Safari
      browserName = 'Yandex';
    } else if (userAgent.match(/(Edge|Edg|EdgA|EdgiOS)\/.*/i)) {
      // How to distinguish Edge Chromium vs other? Just by Blink engine?
      browserName = 'Edge';
    } else if (userAgent.match(/Firefox\/.*/i)) {
      // !userAgent.match(/Seamonkey\/.*/i)
      browserName = 'Firefox';
    } else if (userAgent.match(/Chrome\/.*/i) && !userAgent.match(/Chromium\/.*/i)) {
      // Has to be before Safari
      browserName = 'Chrome';
    } else if (userAgent.match(/Safari\/.*/i) && !userAgent.match(/Chrome\/.*/i) && !userAgent.match(/Chromium\/.*/i)) {
      browserName = 'Safari';
    } else if (userAgent.match(/; MSIE.*;/i)) {
      browserName = 'Internet Explorer <= 10';
    } else if (userAgent.match(/Trident\/.*; rv:.*/i)) {
      browserName = 'Internet Explorer 11';
    } else if (userAgent.match(/Chromium\/.*/i)) {
      browserName = 'Chromium';
    } else {
      browserName = 'Other';
    }
  }
  return browserName;
};

export const isACPEligibile = () => {
  const { cBandPlans } = store.getState();

  return (
    window.vzFlags?.acpIntegrated &&
    cBandPlans.plans?.output?.acpInfo?.nladSubscriberId &&
    cBandPlans.plans?.output?.acpInfo?.nladSubscriberId !== 'null'
  );
};
export const isVfDiscountsFlow = () => {
  let vfdiscount = false;
  if (window.location.href?.indexOf('vfdiscount') > -1) vfdiscount = true;
  return vfdiscount;
};
export const isPlansVisitLq = () => {
  const { plansVisitLq } = window.vzFlags;
  return plansVisitLq || false;
};
export const isVFEligibile = () => {
  if (!window.vzFlags?.vfIntegrated) {
    return false;
  }
  const { cBandPlans, progressivePlans, cartDetails, checkout } = store.getState();
  const isvfProgressivePlans =
    progressivePlans?.progressivePlanAPiResponse?.data?.acpInfo?.benefit &&
    progressivePlans?.progressivePlanAPiResponse?.data?.acpInfo?.benefit === 'VFWD';
  const isVfFromCart = cartDetails?.cartDetailsJson?.acpInfoDetails?.benefit && cartDetails?.cartDetailsJson?.acpInfoDetails?.benefit === 'VFWD';
  const isVfFromcBandPlans = cBandPlans?.plans?.output?.acpInfo?.benefit && cBandPlans.plans?.output?.acpInfo?.benefit === 'VFWD';
  const isVfFromCheckout = checkout?.cart?.acpInfo?.benefit && checkout?.cart?.acpInfo?.benefit === 'VFWD';

  return isVfFromcBandPlans || isvfProgressivePlans || isVfFromCart || isVfFromCheckout;
};
export const isVfNYEnable = () => !!window.vzFlags?.vfNyIntegrated;

export const vfDiscountAriaLabel = (props, isVfNYEnableThunder, state) =>
  isVfNYEnableThunder && state === 'NY' ? props?.vfNyNotificationMessage : props?.vfNotificationMessage;

export const isACPCustomTagging = () => {
  const isACPFlow = getQueryParamByName('acp') === 'y';
  const { acpTagging } = window.vzFlags || {};
  return acpTagging && isACPFlow;
};
export const isWHWISPUFlag = () => {
  const { isWHWISPU } = window.vzFlags || {};
  if (isWHWISPU || getSession(isWHWISPU) === 'Y') {
    return true;
  }
};

export const isWHWPhase2Flag = () => {
  const { isWHWPhase2 } = window.vzFlags || {};
  if (isWHWPhase2 || getSession('isWHWPhase2') === 'Y') {
    return true;
  }
};

export const isWHWP2TermFlag = () => {
  const { isWHWPhase2Term } = window.vzFlags || {};
  return isWHWPhase2Term;
};

export const getPrefetch = (preFetchAEM = false) => {
  let isPrefetch = false;
  const preFetch = getSession(preFetchConsts.SESSION_KEY);
  const { search } = window.location;
  const params = new URLSearchParams(search);
  if (preFetch !== null && preFetch === 'true') {
    isPrefetch = true;
  } else if (
    (params &&
      params != null &&
      params.has(preFetchConsts.QUERYSTRING_KEY) &&
      params.get(preFetchConsts.QUERYSTRING_KEY).toLocaleLowerCase() === 'y') ||
    preFetchAEM
  ) {
    setSession(preFetchConsts.SESSION_KEY, 'true');
    isPrefetch = true;
  }
  return isPrefetch;
};

export const isDTDFlow = () => {
  const isDtdFlow = getSession('isDTD') || window.location.href.indexOf('dtd') > -1 ? 'true' : 'false';

  return isDtdFlow;
};

export const pdcAEMCheck = () => {
  const { pdcFlag } = window.vzFlags || {};
  return !!(pdcFlag === true || getSession('pdcFlag') === 'Y');
};

export const prefetchAddonsAsync = () => {
  const { prefetchAddons } = window.vzFlags || {};
  return !!(prefetchAddons === true || getSession('prefetchAddons') === 'Y');
};

export const fetchAddons = () => {
  const { fetchAddOns } = window.vzFlags || {};
  return !!(fetchAddOns === true || getSession('fetchAddOns') === 'Y');
};

export const prefetchGetShippingOptions = () => {
  const { prefetchGetShipping } = window.vzFlags || {};
  return !!(prefetchGetShipping === true || getSession('prefetchGetShipping') === 'Y');
};

export const prefetchGetShippingOptionsCookie = () => {
  const cookieValue = getCookie('prefetchGetShipping'); // Fetch the cookie value
  return cookieValue === 'Y'; // Return true only if the cookie is explicitly set to 'Y'
};

export const srePrefetchCookie = () => {
  const cookieValue = getCookie('srePrefetch') || false; // Fetch the cookie value
  return cookieValue;
};

export const prefetchGetCheckoutAndSmsEnabled = () => {
  const { prefetchGetCheckoutAndSms } = window.vzFlags || {};
  return !!(prefetchGetCheckoutAndSms === true || getSession('prefetchGetCheckoutAndSms') === 'Y');
};

export const addPlanOnSelectPlanSelection = () => {
  const { addPlanOnPlanSelection } = window.vzFlags || {};
  return !!(addPlanOnPlanSelection === true || getSession('addPlanOnPlanSelection') === 'Y');
};

export function* reflect({ url, data }) {
  try {
    return { v: yield call(url, data), status: 'fulfilled' };
  } catch (err) {
    return { e: err, status: 'rejected' };
  }
}

const isMoversPhase3 = () => getSession('moversPhaseThreeQualFFlag') === 'true';
export const isExpressCheckout = () => isLoggedIn() && !isWHWP2() && !isDeviceUpgradeFlow() && !isMoversPhase3() && !isTitanOneUpgradeFlag();

// export const isExpressCheckout = () => {
//   const pageName = getUrlName(window.location.pathname);
//   return (pageName === 'appointment' && !isLoggedIn())
//     ? isExpressCheckoutNSE()
//     : isLoggedIn() && !isWHWP2() && !isDeviceUpgradeFlow() && !isMoversPhase3() && !isTitanOneUpgradeFlag();
// }

export const isExpressCheckoutNSE = () => {
  const cookieValue = getCookie('fwaProspectExpressCheckout');
  return (cookieValue === 'Y') && !isLoggedIn();
};

export const isEmailOrder = () => isLoggedIn();

export const isDesktop = () => viewport() === 'desktop';

export const renderElement = (element, targetId, renderIf) => {
  try {
    /**
     * Brand 3.0 CTA Shifting
     * Use Case :
     * To move a tightly coupled CTA outside of the component tree
     * Tested alternates:
     * React Ref was not feasible with limitations of AEM children Type
     * HOC was not feasible with AEM container class as it cannot hold any state
     * Context requires more updates and glitches were observed in Credit Check
     * */
    const domNode = document.getElementById(targetId);
    if (!renderIf && domNode) {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.unmountComponentAtNode(domNode);
    } else if (domNode && element) {
      // eslint-disable-next-line react/no-deprecated
      ReactDOM.render(element, domNode);
    }
  } catch (error) {
    // TODO logger
  }
};

export const is5G = getFlowType() === '5G';
export const isLTE = getFlowType() === 'LTE';
export const isBulkQualIndicator = () => {
  if (getSession('bulkQualIndicator') === 'Y') {
    return true;
  }
  return false;
};

export const isCBandProQualifiedSession = () => !!(getSession('isCBandQual') === 'Y' && getSession('cbandPro') === 'Y');

export const resumeOrderCartProcessStepCheck = () => getUrlName(window.location.pathname) === 'cart' && getSession('isResumeOrder') === 'Y' && isExpressCheckoutNSE()
export const isJTFlowFromNGDCart = () => {
  const cdlThrottleList = getCookie('cdlThrottleList') || ''
  const isNGDJTEnabled = cdlThrottleList.includes('ngdJTComboEnabled');
  const isJTFromNGDCart = sessionStorage.getItem('ngdJTCombo') === 'true' || false;
  return enableNgdJTCartFFlag() && isJointTransactionFlow() && isNGDJTEnabled && isJTFromNGDCart;
}
export const buildUpdateProcessStepPayload = (IntendType, data = {}) => ({
    cartInfo: {
      clientAppName: 'VZW-DOTCOM',
      accountNumber: '',
      cartCreator: '',
      processingMTN: isJointTransactionFlow() || isECJointTransactionFlow() ? `${getJointTransactionLine()}` : 'newLine1',
      processStep: resumeOrderCartProcessStepCheck() ? 'ExpressCart' : data?.processStep || 'ShoppingCart',
      processAction: data?.processAction || 'Complete',
      intendType: `${IntendType}`,
      bundleInstallType: '',
      ...(isJTFlowFromNGDCart() && { ngdJTCombo: true }),
    },
    data: {},
});

export const isSelfSetupSelected = () => {
  const state = store.getState();
  const installType = state.cartDetails?.cartDetailsJson?.orderDetailsView?.installType ?? '';
  const depletionType = state.checkout?.depletionType ?? '';

  return installType === 'Self SetUp' || depletionType === 'F' || depletionType === 'L';
};

export const logToContentSquare = (type, message) => {
  window._uxa = window._uxa || [];
  window._uxa.push(['trackPageEvent', `TextMessage ${type}: ${message}`]);
  window._uxa.push(['trackError', `${type}: ${message}`]);
};

export const isCheckoutFlow = () => {
  const pageName = getUrlName(window.location.pathname);
  if (isLoggedIn()) {
    const postCartPages = ['contactinfo', 'shipping', 'orderreview', 'payment', 'moversShipping', 'moversPayment'];
    const isPostCartPage = postCartPages.includes(pageName);
    if (isWHWFlow()) return false;
    if (!isPostCartPage) return false;

    const isSelfSetupOpted = isSelfSetupSelected() || getSession('changeToSelf') === 'Y';
    return isSelfSetupOpted;
  }
  // AEM || COOKIE and shipping
  return (
    getUrlName(window.location.pathname) === 'shipping' && (getCookie('shippingGetCheckoutNSE') === 'Y' || window.vzFlags?.shippingGetCheckoutNSE)
  );
};

export const isFuncComp = () => isCheckoutFlow();

export const isSequentialFlow = () => getSession('isSequentialFlow') === 'Y';

export const isJointTransactionFlow = () => getAPPID() === 'NSE' && getSession('isJointTransaction') === 'true';

export const isECJointTransactionFlow = () => getAPPID() === 'AAL' && getSession('isECJointTransaction') === 'true';

/**
 * Consolidated helper to check if the current flow is any type of Joint Transaction.
 * Returns true for both NSE Joint Transaction (isJointTransaction) and AAL EC Joint Transaction (isECJointTransaction).
 * Use this instead of repeating `isJointTransactionFlow() || isECJointTransactionFlow()`.
 * @returns {boolean} True if either joint transaction flow is active
 */
export const isAnyJointTransactionFlow = () => isJointTransactionFlow() || isECJointTransactionFlow();

/**
 * Helper to get processing MTN from session/cookie for JT pause/resume flows
 * Uses viewport to determine storage type (cookie for mfapp, session for web)
 * @returns {string|null} The stored JT processing MTN or null
 */
export const getJTProcessingMTN = () => (viewport() === 'mfapp' ? getCookie(JT_PROCESSING_MTN_KEY) : getSession(JT_PROCESSING_MTN_KEY));

/**
 * Centralized helper to get processing MTN for JT flows with proper fallback chain
 * Priority: 1) getJointTransactionLine() 2) session/cookie storage 3) default 'newLine1'
 * @returns {string} The processing MTN value
 */
export const getJTProcessingMTNForSetup = () => {
  if (isJointTransactionFlow() || isECJointTransactionFlow()) {
    const jtLine = getJointTransactionLine();
    if (jtLine) return jtLine;
  }
  const jtProcessingMtn = getJTProcessingMTN();
  if (jtProcessingMtn) return jtProcessingMtn;
  return DEFAULT_PROCESSING_MTN;
};

/**
 * Validates a line parameter value against expected format
 * @param {string} lineParam - The line parameter to validate
 * @returns {boolean} True if valid, false otherwise
 */
export const isValidLineParam = (lineParam) => {
  if (!lineParam || typeof lineParam !== 'string') return false;
  return VALID_LINE_PARAM_PATTERN.test(lineParam);
};

/**
 * Stores line param from URL to session/cookie for JT pause/resume flows
 * Only stores if the value passes validation
 * @param {string} lineParam - The line parameter from URL
 * @returns {boolean} True if stored successfully, false otherwise
 */
export const storeJTProcessingMTN = (lineParam) => {
  if (!isValidLineParam(lineParam)) return false;
  if (viewport() === 'mfapp') {
    setCookie(JT_PROCESSING_MTN_KEY, lineParam);
  } else {
    setSession(JT_PROCESSING_MTN_KEY, lineParam);
  }
  return true;
};

export const skipProspectExpressCheckout = () => {
  const skipExpressCheckout = getCookie('disableExpressCheckout') === 'true';
  return skipExpressCheckout || isStreamlineFlow() || isJointTransactionFlow();
};

export const accessbilityAccordion = (planAccordionIsOpen) => {
  setTimeout(() => {
    const elem = document.getElementById('plan-accordion-button');
    if (elem) {
      elem?.focus();
    }
    const msg = !planAccordionIsOpen ? 'expanded' : 'collapsed';
    const role = document.createElement('div');
    role.setAttribute('aria-live', 'assertive');
    role.setAttribute('class', 'sr-only');
    role.innerHTML = msg;
    if (elem) {
      elem.appendChild(role);
    }
  }, 1000);
};

export const getSeqFlowType = () => (getSession('SeqType') ? getSession('SeqType') : '');

export const enablePegaProcessSteps = () => {
  const { enablePegaProcessStep } = window.vzFlags || {};
  return !!(enablePegaProcessStep === true || getSession('enablePegaProcessStep') === 'Y');
};

export const expressCheckoutPegaSteps = () => {
  const { expressCheckoutPegaStep } = window.vzFlags || {};
  return expressCheckoutPegaStep === true || getSession('expressCheckoutPegaStep') === 'Y';
};

export const enablePlanInfoAPICall = () => {
  const { enablePlanInfoAPI } = window.vzFlags || {};
  return !!(enablePlanInfoAPI === true || getSession('enablePlanInfoAPI') === 'Y');
};

export const isRemoveLQResponse = () => {
  const { removeLQResponse } = window.vzFlags || {};
  const lqResponse = getSession('LQResponse') ? JSON.parse(getSession('LQResponse')) : '';
  return !lqResponse || removeLQResponse === true || getSession('removeLQResponse') === 'Y';
};

export const isWWM = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  return getSession('WWM') === 'true' || params.has('wwm_redeem');
};
export const isDeviceUpgradeFlow = () => {
  if (getSession('deviceUpgradeFlag') === 'true') {
    return true;
  }
  return false;
};

export const getAteParam = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const hasTdu = params.has('tdu') && params.get('tdu') === 'true';
  const hasAte = params.has('ate') && params.get('ate') === 'true';
  return hasTdu && hasAte;
};

export const getEParam = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const hasTdu = params.has('tdu') && params.get('tdu') === 'true';
  const hasE = params.has('e') && params.get('e') === 'true';
  return hasTdu && hasE;
};
export const getOnlyEParam = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  return params.has('e') && params.get('e') === 'true';
};
export const getTduParam = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  return params.has('tdu') && params.get('tdu') === 'true';
};

export const isTitanOneUpgradeFlag = () => getSession('titanOneUpgradeFlow') === 'true' || getTduParam();

export const isTitanOneUpgradeFlow = () => getTduParam(); 

export const isTrupUpgradeFlow = () => getEParam();

export const isTrupFlowActive = () => isTRUPFlow() || isTrupUpgradeFlow();

export const nbxSkipTitanOneUpgradeFlag = () => getAteParam(); 

export const titanOneMigrationFWAAcssFFlag = () => getSession('titanOneUpgradeReactiveFlow') === 'true';

export const titanOneMigrationMultilineAcssFFlag = () => getSession('titanOneReactiveMultipleFlow') === 'true';

export const fwaTitanUpgradePoBoxFixFFlag = () => getSession('deviceUpgradePOBoxFlag') === 'true' || getSession('fwaTitanUpgradePoBoxFlag') === 'true';

export const poBoxUpgradeFlowCheck = () => fwaTitanUpgradePoBoxFixFFlag() && (isDeviceUpgradeFlow() || isTitanOneUpgradeFlag());


export const setTitanOneFlowSession = () => {
  const flowType = nbxSkipTitanOneUpgradeFlag() ? 'ate_flow' : 'tdu_flow';
  setSession(flowType, 'true');
}

export const isWHWFlow = () => isWHW() || isWHWP2() || isWWM() || isTitanOneUpgradeFlag() || isDeviceUpgradeFlow();

export const isWWMCustomTagging = () => {
  const { search } = window.location;
  const params = new URLSearchParams(search);
  const isWWMFlow = getSession('WWM') === 'true' || params.has('wwm_redeem');
  return isWWMFlow;
};

export const scrollToTop = () => {
  if (isMobile() || isMobileResolution()) {
    const elem = document.getElementById('topFocus');
    if (elem) {
      elem.focus();
    }
  } else {
    window.scrollTo(0, 0);
  }
};

export const checkErrorCode = (errorCode) => {
  // const ErrorCodes = ["06", "400","615","701","1000","1008","1023","3000","3002","3504","3606","3607","15501","17104"];
  const ErrorCodes = window.vzFlags?.msgwithLinkErrorCode;
  return ErrorCodes.includes(errorCode);
};

export const enableFwaRedesignFFlagSequentail = () => getCookie("enableMiniCartForSequentialFlow") === 'Y';

const isSequentialFlowExcludedByCookie = () => 
  getCookie("enableMiniCartForSequentialFlow") === 'Y' ? false : isSequentialFlow();

const isMiniCartPhase3ExcludedFlow = () => isJointTransactionFlow() || isSequentialFlowExcludedByCookie() || isWHW() || isWHWP2() || isTRUPFlow();

export const isMiniCartPhase3EnabledforNSE = () => 
  // Feature flag is at 100% rollout - always enabled except excluded flows
!isMiniCartPhase3ExcludedFlow() && getAPPID() === 'NSE';
;

export const isMiniCartFooterEnabled = () => getCookie("enablePlansPageMiniCartFFlag") === 'Y' || isMiniCartPhase3EnabledforNSE();

export const isMiniCartPhase3Enabled = () =>
  !isMiniCartPhase3ExcludedFlow() && !isECJointTransactionFlow() && (enableFwaRedesignFFlagSequentail() || !isSequentialFlow());
;
/* istanbul ignore next */
export const isStickyFooterRedesignEnabled = () => 
  // Feature flags are at 100% rollout - isMiniCartPhase3Enabled always returns true
  // enableOrderSummaryRevampFFlag is always 'Y'
   !isJointTransactionFlow() && !isECJointTransactionFlow() && !isSequentialFlowExcludedByCookie();
;
// export const isStickyFooterRedesignEnabled = () => true;

export const throttleValueForMiniCartRedesign= () => {
    let throotleValueNeeded = true;
    if(getAPPID() === 'NSE' || isJointTransactionFlow() || isECJointTransactionFlow() || isSequentialFlow() || (getAPPID() ==='AAL' && getSession('ExistingCase') === 'true')){
      throotleValueNeeded = false;
    }
    return throotleValueNeeded;
}
export const isNSEJointOrSequentialFlow = () => isJointTransactionFlow() || isSequentialFlow();
// 
export const isCompactPerk = (featureFlag = false) => {
  if (!featureFlag) return false;
  const pageName = getUrlName(window.location.pathname);
  return pageName === 'expresscheckout';
};

export const isShippingEditFlow = () => getSession("expChkOutShippingEdit") === 'Y';

export const isEnableMiniCartPhase3TaggingFFlag = () => {
  const miniCartCheckoutFFlag = getCartData()?.featureFlags?.enableMiniCartPhase3TaggingFFlag || false;
  const plansMiniCartFFlag = store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.enableMiniCartPhase3TaggingFFlag || false;
  return miniCartCheckoutFFlag || plansMiniCartFFlag;
};
export const isEnablePerksTermsTextFFlag = () => {
  const enablePerksTermsTextFFlag =
    store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.enablePerksTermsTextFFlag || false;
  return enablePerksTermsTextFFlag;
};

export const checkFccLabel = () => {
  const { isBroadBandFacts } = window.vzFlags || {};
  return isBroadBandFacts === true || getSession('isBroadBandFacts') === 'Y';
};

export const phoneNumberValidationCheck = () => {
  const nonVzConsent_dark = window.vzFlags?.nonVzConsent_dark;
  if (nonVzConsent_dark === true) {
    return true;
  }
  return false;
};

export const showLocalOffer = () => {
  const { localOfferFlag } = window.vzFlags || {};
  return localOfferFlag === true || localOfferFlag === 'true' || getSession('localOfferFlag') === 'Y';
};

export const showFwaModalFun = () => {
  const { fwaModalFlag } = window.vzFlags || {};
  return fwaModalFlag === true || fwaModalFlag === 'true' || getSession('fwaModalFlag') === 'Y';
};

export const checkDisneyperkRedirection = () => {
  const { redirectToPerks } = window.vzFlags;
  return redirectToPerks || false;
};

/**
 * Check if it is disney bundle promo.
 *
 * @return {boolean} True if it is disney bundle promo, false otherwise.
 */
export const checkIsDisneyBundlePromo = () => {
  const { enableDisneyBundlePromo } = window.vzFlags;
  return enableDisneyBundlePromo || false;
};

export const isDisneyPromoEligible = (planData, selectedPlan) => {
  const selectedPlanId = selectedPlan?.planId || '';
  const availablePromos = planData?.data?.lineLevelPlans?.lines?.[0]?.availablePromos || [];
  const eligibleDisneyPromo = availablePromos?.filter((item) => item.spoId === VISION_FEATURE_CODE);
  const eleigiblePlanIds = eligibleDisneyPromo?.[0]?.eligiblePlanIds || [];
  if (checkIsDisneyBundlePromo() && selectedPlanId && eleigiblePlanIds && eleigiblePlanIds?.includes(selectedPlanId)) {
    return true;
  }
  return false;
};

export const isWifiBackupMLP = () => {
  const widgetHost = getSession('widgetHost') ? getSession('widgetHost') : '';
  return widgetHost === wifiTransactionType;
};

export const isWifiBackupPlanToBeDisplayed = (toggleExplore = '') => {
  let isWifiPlan = false;
  const qualificationResponseData = getLqDetails();
  const {
    qualifiedCBand = false,
    qualified4GHome = false,
    wifiBackupCbandQualified = false,
    wifiBackupLteQualified = false,
    qualified = false,
  } = qualificationResponseData;
  const wifiBackupMLP = isWifiBackupMLP();
  if (
    (wifiBackupMLP && (wifiBackupCbandQualified || wifiBackupLteQualified)) ||
    (!wifiBackupMLP && !qualifiedCBand && !qualified4GHome && (wifiBackupCbandQualified || wifiBackupLteQualified) && !qualified && !isVHILiteFlow())
  ) {
    isWifiPlan = true;
  }
  if (toggleExplore === 'wifi') {
    isWifiPlan = true;
  } else if (toggleExplore === '5G') {
    isWifiPlan = false;
  }
  return isWifiPlan;
};

export const checkAddressQualification = (qualification) => {
  const qualificationResponseData = getLqDetails();
  const {
    qualifiedCBand = false,
    qualified4GHome = false,
    wifiBackupCbandQualified = false,
    wifiBackupLteQualified = false,
    qualified = false,
  } = qualificationResponseData || {};
  let isPlansQualified = false;
  if ((qualification === WIFI_BACKUP && (wifiBackupCbandQualified || wifiBackupLteQualified)) || (qualification === FWA_PLANS && (qualifiedCBand || qualified4GHome || qualified || isVHILiteFlow()))) {
    isPlansQualified = true;
  }
  return isPlansQualified;
};

export const getWifiBackupPlanIntendType = () => {
  const qualificationResponseData = getLqDetails();
  const { wifiBackupCbandQualified = false } = qualificationResponseData;
  if (getAPPID() === 'AAL') {
    return wifiBackupCbandQualified ? 'AAL_5G' : 'AAL_LTE';
  }
  return wifiBackupCbandQualified ? 'NSE_5G' : 'NSE_LTE';
};

export const getTransactionLine = () => {
  if (getJointTransactionLine()) {
    return getJointTransactionLine();
  }
  return 'newLine1';
};

export const isThunderFFlag = () => {
  const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.thunderFFlag || false;
};

export const istgwRestrictBetaCustomersFFlag = () => {
 const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.tgwRestrictBetaCustomersFFlag || false;
}

export const checkOnly5GHomePlan = () => {
 const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.showOnlyFiveGHomeFFlag || false;
}

export const enableContinueCTAforTGW = () => {
 const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.enableContinueCTAforTGWFFlag || false;
}
export const googlePromoDefectFixesFFlag = () => {
  const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.googlePromoDefectFixesFFlag || false;
};
export const isPerkPromoEligible = (planData, selectedPlan, spoId) => {
  const selectedPlanId = selectedPlan?.planId || '';
  const availablePromos = planData?.data?.lineLevelPlans?.lines?.[0]?.availablePromos || [];
  const eligiblePerkPromo = availablePromos?.filter((item) => item.spoId === spoId);
  const eleigiblePlanIds = eligiblePerkPromo?.[0]?.eligiblePlanIds || [];
  return eleigiblePlanIds?.some((planId) => planId?.trim() === selectedPlanId);
};

export const isLargedesktop = () => window.innerWidth >= 1650;

export const checkRole = () => {
  const roleValue = getCookie('role') || getCookie('accountRole');
  if (!roleValue) return false;
  
  const lowerRole = roleValue.toLowerCase();
  return lowerRole === 'mobilesecure' || lowerRole === 'accountmember';
};

const debounceFunc = () => {
  let timer;
  // eslint-disable-next-line func-names
  return function (callBackFn, value, timervalue) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      console.log('TESTER', value);
      callBackFn();
    }, timervalue);
  };
};
export const debounce = debounceFunc();

export const safeTechScript = (safetechSessionId) =>
  window.vzFlags && window.vzFlags.isProd
    ? `https://ssl.kaptcha.com/collect/sdk?m=300637&s=${safetechSessionId}`
    : `https://tst.kaptcha.com/collect/sdk?m=300637&s=${safetechSessionId}`;

export const checkUnitAvailability = (id, address2, availableAddressUnit, isOnlyTypeAhead) => {
  if (
    id === 'address2' &&
    isOnlyTypeAhead === 'no' &&
    address2 &&
    availableAddressUnit &&
    Number(availableAddressUnit?.totalHits) > 0 &&
    availableAddressUnit?.data
  ) {
    const address2Value = address2?.replace(/\s+/g, ' ');
    const availableUnit = availableAddressUnit?.data.filter((unit) => unit?.sublocation?.toLowerCase() === address2Value.trim().toLowerCase());
    return availableUnit?.[0]?.sublocation || '';
  }
  return address2;
};

export const checkStandAloneFccPage = () => {
  if (getCookie('category') && getCookie('site')) {
    return true;
  }
  return false;
};

export const fccConstantValues = {
  flowName: {
    Prepaid: 'PREPAID',
    Unlimited: 'UNLIMITED',
    'Connected-Devices': 'CONNECTED_DEVICES',
    '55+': '55+',
  },

  learnPageFlow: 'InternalFlow',
  NationalRetailerFlow: 'NRFlow',
  subCategories: {
    Prepaid: ['Phoneplan', 'Dataplan', 'Smartwatchplan', 'Hotspotrouterplan'],
    'Connected-Devices': ['Tablet', 'Laptop', 'Smartwatch', 'Mobilehotspot', 'Security', 'ConnectedCar'],
    Unlimited: [],
    '55+': [],
  },
  cookieValue: {
    Prepaid: 'Prepaid',
    Unlimited: 'Unlimited',
    'Connected-Devices': 'Connected-Devices',
    '55+': '55+',
  },
};

// eslint-disable-next-line arrow-body-style
export const getFCCFlowName = () => {
  return {
    flowName: fccConstantValues?.flowName?.[getCookie('category')] || '',
    subFlowName: getCookie('subCategory') || '',
    site: getCookie('site') || '',
  };
};

export const isHomeInternetBroadBandFlow = () => {
  if ((getSession('fcc') === 'true' || getCookie('fcc') === true || getCookie('fcc') === 'true') && !checkStandAloneFccPage()) {
    return true;
  }
  return false;
};

export const isFCCInternalPage = () => {
  if (getCookie('site') === 'InternalFlow' && (getCookie('isFCCInternalPage') === 'true' || getCookie('isFCCInternalPage') === true)) {
    return true;
  }
  return false;
};

export const isCartCIThrottlePass = (throttleListResult) =>
  throttleListResult &&
  (throttleListResult.includes(cradleThrottleValues.CART_CONTACT_INFO_INTG_ENABLED) ||
    throttleListResult.includes(cradleThrottleValues.CART_CONTACT_INFO_INTG_WHITELISTED));

export const cartContactInfoIntg = () => isLoggedIn();

export const isShippingTabEnabled = () => {
  const cradleResponse = store.getState()?.SessionValues?.shippingCradleValue;
  const isThrottled = cradleResponse?.includes('FWA_Express_T_Pickup') || getSession('shippingTabRedesign') === 'Y';
  return isThrottled;
};

export const noStoreTile = () => {
  const nonMobileWidth = isDesktop() ? '398px' : 'calc(calc(100% - 12px) / 2)';
  return (
    <div style={{ marginTop: '20px' }}>
      <RadioBox
        disabled
        outOfStock
        text="Free in-store pickup"
        subtext={parse('<br>No store close to your service address')}
        subtextRight="$0.00"
        orientation="vertical"
        width={isMobile() ? '' : nonMobileWidth}
      />
    </div>
  );
};

export const enableAutopayPreview = () => {
  // ACT145-1672 - Code Clean up : FWA Cradle API Optimizations SOE UI
  const { SessionValues } = store.getState() || {};
  const throttlePass = SessionValues?.fwaCradleValues?.includes('|autopay-preview|');

  const autoPayPreview = getSession('autoPayPreview') === 'Y';
  if (autoPayPreview && !isLoggedIn()) {
    return true;
  }
  return throttlePass && !isLoggedIn();
};

export const GetProcessStepPages = (processStep) => {
  if (!pageList?.length || !processStep) {
    return '';
  }
  const [page] = pageList.filter((item) => item.key === processStep);
  return page?.value ?? '';
};

export const GetCurrentPageName = () => {
  const name = getUrlName(window.location.href);
  return `${name}.html`;
};

export const GetisFromProgressBar = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const fromParam = urlParams.get('from') || '';

  const progressPages = ['expresscheckout', 'shipping', 'appointment', 'payment', 'expresstos'];

  const isFromProgressBar = progressPages.some((page) => fromParam.includes(page));

  return isFromProgressBar;
};

export const saveAllProcessSteps = () => {
  const name = getUrlName(window.location.href);
  const { Redirection } = store.getState();
  let processStepArray = [];
  processStepArray = Redirection?.allProcessStep;
  if (!Redirection?.allProcessStep.includes(`${name}.html`)) {
    processStepArray.push(`${name}.html`);
  }
  return processStepArray;
};

export const states = [
  'AK',
  'AL',
  'AR',
  'AZ',
  'CA',
  'CO',
  'CT',
  'DC',
  'DE',
  'FL',
  'GA',
  'HI',
  'IA',
  'ID',
  'IL',
  'IN',
  'KS',
  'KY',
  'LA',
  'MA',
  'MD',
  'ME',
  'MI',
  'MN',
  'MO',
  'MS',
  'MT',
  'NC',
  'ND',
  'NE',
  'NH',
  'NJ',
  'NM',
  'NV',
  'NY',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VA',
  'VT',
  'WA',
  'WI',
  'WV',
  'WY',
];

export const getJointTransactionLine = () => {
  const { SessionValues } = store.getState() || {};
  return SessionValues?.jointTransactionLine ?? '';
};

export const isMoversPhase2 = () => getSession('moversPh2') === 'true' || getCookie('moversPh2') === 'true';

export const populatePlanNameAndCustomerInfo = (str = '', planName, mtn, firstName) => {
  let newStr = str.replace('{planName}', planName);
  newStr = newStr.replace(
    '##MDN##',
    `${firstName}-${mtn?.substring(mtn?.length - 4)} ${mtn?.substring(0, 3)}.${mtn?.substring(3, 6)}.${mtn?.substring(6)}`,
  );
  return newStr;
};

export const printAgreement = (content) => {
  const pri = document.getElementById('printFrame').contentWindow;
  pri.document.open();
  const iframeStyle =
    '<style type="text/css">  @media print { a { color: black; border-bottom: none !important; text-decoration: none !important; } } </style>';
  pri.document.write(content + iframeStyle);

  pri.document.close();
  pri.focus();
  const isSafari =
    navigator.vendor &&
    navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') === -1 &&
    navigator.userAgent.indexOf('FxiOS') === -1;
  if (isSafari) {
    pri.execCommand('print', false, null);
  } else {
    pri.print();
  }
  pri.close();
};

export const getLQWidgetConfig = (sourceInfo, seqType = '') => {
  const isProd = window.vzFlags?.isProd;
  const lqScriptURL = isProd ? 'https://www.verizon.com/inhome/vzlqwidget.js' : 'https://www98.verizon.com/inhome/vzlqwidget.js';
  const lqSCURL = isProd
    ? '//assets.adobedtm.com/2ea7ee22c8c2/ece9aa9bcf6f/launch-72284e178e44.min.js'
    : '//assets.adobedtm.com/2ea7ee22c8c2/ece9aa9bcf6f/launch-61f2528ef72a-development.min.js';

  return {
    lqScriptURL,
    lqSCURL,
    vzwlqwidgetconfig: {
      targetElementId: 'lq-widget-root',
      lqApi: 'LOCUS_API',
      platform: '5G',
      flowType: '',
      sourceInfo,
      seqType,
      renderSettings: {
        mode: 'modal',
        externalTrigger: ['#checkLq'],
        miniLq: {
          enabled: false,
          layout: {},
        },
      },
    },
  };
};

export const getLQWidgetPlanConfig = (sourceInfo, seqType = '', extraParams = {}) => {
  const isProd = window.vzFlags?.isProd;
  const lqScriptURL = isProd ? 'https://www.verizon.com/inhome/vzlqwidget.js' : 'https://www98.verizon.com/inhome/vzlqwidget.js';
  const lqSCURL = isProd
    ? '//assets.adobedtm.com/2ea7ee22c8c2/ece9aa9bcf6f/launch-72284e178e44.min.js'
    : '//assets.adobedtm.com/2ea7ee22c8c2/ece9aa9bcf6f/launch-61f2528ef72a-development.min.js';

  return {
    lqScriptURL,
    lqSCURL,
    vzwlqwidgetconfig: {
      targetElementId: 'lq-widget-root',
      lqApi: 'LOCUS_API',
      platform: '5G',
      flowType: '',
      sourceInfo,
      seqType,
      theme: extraParams?.theme,
      renderSettings: {
        mode: 'modal',
        externalTrigger: ['.checkAvailabilityBtn'],
        miniLq: {
          enabled: true,
          layout: {
            default: {
              topPosition: '69px',
              zIndex: '900',
            },
            mq_lg: {
              breakPoint: '1020px',
              topPosition: '120px',
              zIndex: '899',
            },
          },
          options: { sticky: 'false' },
        },
      },
    },
  };
};

export const parseHTML = (data) => {
  try {
    return parse(data);
  } catch (e) {
    return '';
  }
};

export const getPlanSelectionJourney = () =>
  (getSession('planSelectionJourney') !== 'undefined' &&
    getSession('planSelectionJourney') !== 'null' &&
    JSON.parse(getSession('planSelectionJourney'))) ||
  {};

export const setPlanSelectionJourney = (planSelectionJourney) =>
  planSelectionJourney !== undefined && planSelectionJourney !== null && setSession('planSelectionJourney', JSON.stringify(planSelectionJourney));

export const isYoutubePremiumSelected = () => window.vzFlags?.isYoutubePremiumEnabled ?? false;

export const getdeviceType = () => {
  let deviceType = 'desktop';
  const userAgent = window.navigator.userAgent.toLowerCase();
  if (userAgent && (userAgent.indexOf('android') !== -1 || userAgent.indexOf('iphone') !== -1)) {
    deviceType = 'mobile';
  }
  return deviceType;
};
export const isNotEmpty = (value) => {
  if (value !== undefined && value !== null && value !== '') {
    return true;
  }
  return false;
};

export const getWHWSpoCookie = (name) => {
  const nameEQ = `${name}=`;
  const ca = document?.cookie?.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return JSON.parse(c?.substring(nameEQ.length, c.length));
  }

  return null;
};

export const getTimeZoneAbbreviation = () => {
  const date = new Date();
  const localeString = new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' }).format(date);
  const timeZoneName = localeString?.split(', ')[1];
  const timeZoneSplit = timeZoneName?.split(' ');
  if (timeZoneSplit?.length === 1 && timeZoneName === 'GMT-08:00') return 'PDT';
  return timeZoneSplit?.map((word) => word?.charAt(0))?.join('');
};

export const closePlanLqWidget = () => {
  const closeButton = window.document.getElementById('closeWidget');
  if (closeButton) {
    closeButton.click();
  }
};

export const tgwLine = '5G Home Internet';

export const updateAccessbilityContent = (title, mainTitle = '') => {
  const pageTitleContent = document.querySelector('#pageTitleContent');

  if (pageTitleContent && title) {
    setTimeout(() => {
      pageTitleContent.innerHTML = `${mainTitle} ${title}`;
    }, 200);
  }
};

export const formatHyphenNPANXX = (number) => `${number?.slice(0, 3)}-${number?.slice(3, 6)}-XXXX`;

export const formatDotNPANXX = (number) => `${number?.slice(0, 3)}.${number?.slice(3, 6)}.XXXX`;

export const getCheckoutExpressCart = () => {
  let showCheckout = true;
  const pageName = getUrlName(window.location.href);
  const deviceUpgradeVal = isDeviceUpgradeFlow() && pageName === 'payment';

  if (
    pageName === 'addons' ||
    pageName === 'setup' ||
    deviceUpgradeVal ||
    pageName === 'confirmation' ||
    pageName === 'appointment' ||
    pageName === 'streamlineordering' ||
    pageName === 'creditstatus' ||
    pageName === 'creditcheck' ||
    pageName === 'createprofile' ||
    pageName === 'contactinfo' ||
    pageName === 'progressiveplan'
  ) {
    showCheckout = false;
  }
  let showgetCheckout = false;
  const isProspectFlow = isExpressCheckoutNSE();
  if ((isExpressCheckout() || isProspectFlow) && showCheckout) {
    showgetCheckout = true;
  }
  return showgetCheckout;
};

export const isExpressCheckoutFLow = () => isExpressCheckout() || isExpressCheckoutNSE();

export const getHeaderAndFooterComponent = () => {
  window.gnavdl.options['hide-item'] = ['promoRibbon'];
  window?.refreshGnav('');
  const footer = document.getElementById('vz-gf20');
  if (footer) {
    footer.style.display = 'block';
    footer.style.paddingTop = '50px';
  }
};

export const registerApiPrefetchOnRenderComplete = (elemNode, cb) => {
  const getTranformationSize = (el) => el.clientWidth + el.clientHeight;
  const observer = new MutationObserver((mutation) => {
    for (const el of mutation) {
      if (el && el.target && getTranformationSize(el.target) > 1000) {
        cb();
        observer.disconnect();
        break;
      }
    }
  });
  observer.observe(elemNode, { subtree: true, childList: true, attributes: true });
};

export const getWHWSPODetails = () => {
  try {
    const WHWSession = viewport() === 'mfapp' ? getWHWSpoCookie('whwSpoDetails') : getSession('whwSpoDetails');
    return WHWSession ? JSON.parse(WHWSession) : {};
  } catch (parseError) {
    return {};
  }
};

export const getWHWProcessingMTN = () => (viewport() === 'mfapp' ? getCookie('whwProcessingMTN') : getSession('whwProcessingMTN'));

export const getWHWSpoId = (spo) => spo?.spoId || spo?.spoid;

/** @param {object} [featureFlagMap] Optional map for tests; defaults to getAddOnsDetails featureFlagMap in store */
export const beaconWhwRedemptionFFlag = (featureFlagMap) => {
  const flags = featureFlagMap ?? store?.getState()?.addons?.featureFlagMap;
  return flags?.beaconWhwRedemptionFFlag || false;
};

/** Text-only beacon WHW cap flag from getAddOnsDetails (independent of beaconWhwRedemptionFFlag) */
export const beaconWhwRedemptionTextFFlag = (featureFlagMap) => {
  const flags = featureFlagMap ?? store?.getState()?.addons?.featureFlagMap;
  return flags?.beaconWhwRedemptionTextFFlag || false;
};

/** Beacon WHW downgrade CTA flag — gates SPO-based Selected/Downgrade logic in tileData */
export const beaconWhwDowngradeFFlag = (featureFlagMap) => {
  const flags = featureFlagMap ?? store?.getState()?.addons?.featureFlagMap;
  return flags?.beaconWhwDowngradeFFlag || false;
};

export const isWHWBeaconFlow = (featureFlagMap) => {
  if (!beaconWhwRedemptionFFlag(featureFlagMap)) {
    return false;
  }
  const whwDetails = getWHWSPODetails();
  return !!(whwDetails?.buddyLineMtn && whwDetails?.convergedMtn);
};

/** Beacon WHW cap text flow — gated by beaconWhwRedemptionTextFFlag so text can stay on if old beacon flag is off */
export const isWHWBeaconTextFlow = (featureFlagMap) => {
  if (!beaconWhwRedemptionTextFFlag(featureFlagMap)) {
    return false;
  }
  const whwDetails = getWHWSPODetails();
  return !!(whwDetails?.buddyLineMtn && whwDetails?.convergedMtn);
};

export const isBeaconUpgradeFlow = (data, featureFlagMap) =>
  isWHWBeaconFlow(featureFlagMap) &&
  !!data?.addWHWPlan?.isUpgradeFlow &&
  !data?.addWHWPlan?.isDownGradeRedeem &&
  !data?.addWHWPlan?.isRedeemButton;

export const getWHWBuddyLineMtn = () => {
  if (!isWHWBeaconFlow()) {
    return getWHWProcessingMTN();
  }
  return getWHWSPODetails().buddyLineMtn;
};

export const getWHWConvergedMtn = () => {
  if (!isWHWBeaconFlow()) {
    return getWHWProcessingMTN();
  }
  return getWHWSPODetails().convergedMtn;
};

export const getWHWAccessoryProcessingMTN = () => getWHWBuddyLineMtn();

export const getWHWAccessoryLineMtn = () => getWHWBuddyLineMtn();

export const triggerScroll = (containerId) => {
  setTimeout(
    () => {
      const container = document?.getElementById(containerId);
      if (container) {
        container.scrollIntoView({ behavior: 'smooth' });
      }
    },
    isMobile() ? 1000 : 1,
  );
};

export const linkClickTagging = ({ buttonText = '' }) => {
  window?.vztag?.api?.dispatch('linkClick', {
    name: buttonText,
    svars: {
      eVar27: buttonText,
    },
  });
};

export const sortPromotions = (promotions) => {
  const choiceOffers = promotions?.filter((item) => item?.choiceOffer);
  const nonChoiceOffers = promotions?.filter((item) => !item?.choiceOffer);
  const promos = [...choiceOffers, ...nonChoiceOffers];
  return promos;
};

export const checkVisionPending = (selectedCategory) => {
  const whwSpoData = getWHWSPODetails();
  const isVisionPending = isWHWP2() && whwSpoData?.visionPendingOrder;
  const monNumber = isWHWP2() && whwSpoData?.mon;
  const visionPendingOrder = isVisionPending && monNumber && isVisionPending !== '' && monNumber !== '';
  const hasVisionPending =
    isWHWP2() &&
    visionPendingOrder &&
    whwSpoData.extenderOnProfile === '2' &&
    whwSpoData?.spoDetails.length > 0 &&
    whwSpoData?.spoDetails?.find((obj) => obj?.current === true)?.categoryCode === selectedCategory;
  if (hasVisionPending) {
    return true;
  }
  return false;
};

export const removeDuplicatePerks = (selectedPerks) =>
  selectedPerks?.filter((obj1, i, arr) => arr.findIndex((obj2) => obj2?.spoId === obj1?.spoId) === i);

export const getOffers = (offers) => {
  if (!offers?.length) {
    return null;
  }
  const result = [];
  offers?.forEach((offer) => {
    const itemHeader = offer?.promoBadges?.find((badge) => badge?.placement === 'ITEM-HEADER');
    const itemBody = offer?.promoBadges?.find((badge) => badge?.placement === 'ITEM-BODY');
    if (itemHeader || itemBody) {
      result.push({
        header: itemHeader?.badgeText,
        body: itemBody?.badgeText,
        offerId: offer?.offerId || offer?.offerID,
        badgeToolTipUrl: itemBody?.badgeToolTipUrl,
        badgeToolTip: itemBody?.badgeToolTip,
      });
    }
  });
  return result;
};

export const findItemHeaderAndBodyNodes = (promotions) => {
  const promoIntent = promotions?.[0]?.promoIntent || [];
  if (!promoIntent?.length) {
    return null;
  }
  const sbdOffer = promotions?.[0]?.sbdOffer;
  const thirdPartyOffer = promotions?.[0]?.thirdPartyOffer;
  const offers = [];
  promoIntent?.forEach((element) => {
    if (sbdOffer && sbdOffer?.length) {
      const sbItems = sbdOffer?.filter((promo) => promo?.offerId === element?.offerId);
      if (sbItems?.length) {
        offers.push(...sbItems);
      }
    }
    if (thirdPartyOffer && thirdPartyOffer?.length) {
      const thirdPItems = thirdPartyOffer?.filter((promo) => promo?.offerID === element?.offerId);
      if (thirdPItems?.length) {
        offers.push(...thirdPItems);
      }
    }
  });
  if (offers?.length) {
    return getOffers(offers);
  }
  return null;
};

export const findCombinedOffers = (choiceOffers, rebateAndLocalOffers, thirdPartyOffers, sbdOffers) => {
  const nonChoiceOffers = [];
  if (Array.isArray(thirdPartyOffers)) {
    thirdPartyOffers.forEach((item) => {
      const isNotChoiceOffer = item?.promoBadges?.some((badge) => !badge?.choiceOffer);
      if (isNotChoiceOffer && item?.offerID !== '409658') {
        nonChoiceOffers.push({
          offerId: item?.offerID,
          discAmt: item?.discAmt,
          header: item?.marketingDescription,
          body: 'To be redeemed post order',
          badgeToolTip: item?.promoBadges?.[0]?.badgeToolTip || '',
          badgeToolTipUrl: item?.promoBadges?.[0]?.badgeToolTipUrl || '',
        });
      }
    });
  }
  const combinedPromos = [
    ...(Array.isArray(choiceOffers)
      ? choiceOffers.map((item) => ({
        ...item,
        body: item?.body ? item?.body : 'To be redeemed post order',
      }))
      : []),
    ...nonChoiceOffers,
    ...(Array.isArray(rebateAndLocalOffers)
      ? rebateAndLocalOffers.map((item) => ({
        ...item,
        offerId: item?.propositionId,
        header: item?.description,
        body: 'To be redeemed post order',
        badgeToolTipUrl: item?.promoBadges?.[0]?.badgeToolTipUrl || '',
        badgeToolTip: item?.promoBadges?.[0]?.badgeToolTip || '',
        rebateOffer: true,
      }))
      : []),
    ...(Array.isArray(sbdOffers)
      ? sbdOffers.map((item) => ({
        ...item,
        offerId: item?.offerId,
        header: item?.promoBadges?.find((badge) => badge?.placement === 'ITEM-HEADER')?.badgeText,
        body: 'To be redeemed post order',
        badgeToolTipUrl: item?.promoBadges?.[0]?.badgeToolTipUrl,
        badgeToolTip: item?.promoBadges?.[0]?.badgeToolTip,
      }))
      : []),
  ];
  const uniqueOffersMap = [...new Map(combinedPromos?.map((item) => [item.offerId, item])).values()];
  return uniqueOffersMap;
};

// check resoltion and viewport for desktop
export const isDesktopResolutionViewPort = () => window.innerWidth >= 1025 && viewport() === 'desktop';

export const toCamelCase = (str) => {
  if (str && str.trim()) {
    return str
      .trim()
      ?.split(' ')
      ?.map((w) => w[0]?.toUpperCase() + w?.substr(1)?.toLowerCase())
      ?.join(' ');
  }
  return null;
};

export const getCartData = () => {
  const state = store?.getState();
  if (getCheckoutExpressCart()) {
    return state?.checkout?.getCheckoutResponse?.data;
  }
  return state?.cartDetails?.cartDetailsJson;
};

export const isFLDiscountFFlag = () => {
  const storeDetails = store?.getState();
  const mnhFlorida55PlusDiscountFFlag =
    storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.mnhFlorida55PlusDiscountFFlag || false;
  return mnhFlorida55PlusDiscountFFlag;
};

export const isCbandStalledPopularplansFFlag = () => {
  const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.cbandStalledPopularplansFFlag;
};

export const isCbandStallVal = () => {
  const LQResponseData = getSession('LQResponse');
  const output = LQResponseData && JSON.parse(LQResponseData)?.output;
  const availableSpeedTier = output?.availableSpeedTier ;
  const networkBandwidthType = (output?.networkBandwidthType === "cbd" || output?.networkBandwidthType === "CBD") || false;
  const cbandStalledVal = availableSpeedTier && availableSpeedTier !=='' && networkBandwidthType;
  return cbandStalledVal;
};

export const isCbandStalledFlow = () => isCbandStallVal() && isCbandStalledPopularplansFFlag();

export const isPlanPerkUIEnhancementFFlag = () => {
  const storeDetails = store?.getState();
  const planPerkUIEnhancementFFlag =
    storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.soHomePlanPerksOptimizeFFlag || false;
  return planPerkUIEnhancementFFlag;
};

export const isShowAllPerksFFlag = () => {
  const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.fwaShowAllPerksFFlag || false;
};

export const showGetPerkForJT = () => isJointTransactionFlow();

export const isSkipPerktoCheckoutFFlag = () => {
  const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags?.isSkipPerktoCheckoutFFlag || false;
};

export const isCbandFromCPC = () => {
  const networkBandwidthType = viewport() === 'mfapp' ? getCookie('FWA_NBT') : getSession('FWA_NBT');
  return networkBandwidthType?.toLowerCase() === 'cbd';
}

export const isThunderWHWPlan = () => {
  const isThunderWHWPlanFlag = viewport() === 'mfapp' ? getCookie('isThunderWHWPlan') : getSession('isThunderWHWPlan');
  return isThunderWHWPlanFlag === 'true';
};

export const isVHILiteExtraWHWPlan = () => {
  const isVHILiteExtraWHWPlanFlag = viewport() === 'mfapp' ? getCookie('isVHILiteExtraWHWPlan') : getSession('isVHILiteExtraWHWPlan');
  return isVHILiteExtraWHWPlanFlag === 'true';
};

export const getPriceGuaranteeFooterIndicator = () => '**';
export const whwTitleReviewDetailsAccessibilityFFlag = () => getCartData()?.featureFlags?.whwTitleReviewDetailsAccessibilityFFlag;
export const ispuBannerDisplayFFlag = () => getCartData()?.featureFlags?.ispuBannerDisplayFFlag;
export const sroFWARetrieveCartFFlag = () => getCartData()?.featureFlags?.sroFWARetrieveCartFFlag;
export const sroPerkPricingMiniCartFFlag = () => getCartData()?.featureFlags?.sroPerkPricingMiniCartFFlag;
export const whwRouterTileFFlag = () => getCartData()?.featureFlags?.whwRouterTileFFlag;
export const getExpressCheckoutNotificationBannerFFlag = () => getCartData()?.featureFlags?.expressCheckoutNotificationBannerFFlag;
export const whwUpgradeQtyFFlag = () => getCartData()?.featureFlags?.whwUpgradeQtyFFlag;
export const whwPOBoxErrorFFlag = () => getCartData()?.featureFlags?.whwPOboxFFlag;
export const whwCreditCheckFFlag = () => getCartData()?.featureFlags?.whwCreditCheckFFlag;
export const whwServiceAddressCheckFFlag = () => isWHWP2() && getCartData()?.featureFlags?.whwServiceAddressCheckFFlag;
export const whwShippingOtpFFlag = () => getCartData()?.featureFlags?.shippingOtpFFlag;
export const getFwaTechRecommenderCBandSOEDigitalFFlag  = () => getCartData()?.featureFlags?.fwaTechRecommenderCBandSOEDigitalFFlag;
export const getTechRecommendation  = () => store?.getState()?.cartDetails?.cartDetailsJson?.cart5GAddress?.techRecommendation;
export const enableNgdJTCartFFlag  = () => getCartData()?.featureFlags?.enableNgdJTCartFFlag || false;
export const professionalSetupWaiverFixFFlag = () => getCartData()?.featureFlags?.professionalSetupWaiverFixFFlag || false;

export const isSROPromo = (offerId) => {
  const cartDetails = getCartData();
  return cartDetails?.promotions?.[0]?.sbdOffer?.some((offer) => offer?.offerId === offerId && offer?.offerTypeCd === 'SO');
};

export const getSubtitleFromPromobadges = (offerId) => {
  const promoBadges = getCartData()?.promotions?.[0]?.sbdOffer?.find(
    (offer) => offer?.offerId === offerId && offer?.offerTypeCd === 'SO',
  )?.promoBadges;
  return promoBadges?.find((badge) => badge.placement === 'ITEM-BODY')?.badgeText || '';
};

export const getValidityText = (noOfDays) => `${noOfDays / 30} months on us`;

export const getSoThrottleValue = (suffix = '') => {
  let throttleValue = '';
  const cradleData = getCookie('cdlThrottleList') || '';
  if (cradleData?.includes('LQSO_T_Streamline') || sessionStorage.getItem('widgetLQHost') === 'Streamline') {
    throttleValue = 'so_y|pred_y';
  } else if (cradleData?.includes('LQSO_C_Streamline')) {
    throttleValue = 'so_n|pred_n';
  }
  const suffixThrottle = throttleValue ? `${throttleValue}|${suffix}` : suffix;
  return `${suffix ? suffixThrottle : throttleValue}`;
};

export const showAppleOnePriceUpMessage = (id) => appleOnePriceUpIds?.includes(id);
export const getFilteredPromotions = (isGooglePromoDefectFixesEnabled, planInfo, perkId, fulfillmentCode) => {
  const promotions = Array.isArray(planInfo?.promotions) ? planInfo.promotions : [];

  return isGooglePromoDefectFixesEnabled ? promotions.filter(
    (promo) => (
      promo?.promoType === 'PERK' &&
      promo?.spoId === perkId &&
      (!fulfillmentCode || promo?.sedOfferId === fulfillmentCode)
    )
  ) : [];
};
export const getPlanPerkPromoBadge = (planData, selectedPlan, perkId, placement) => {
  const selectedLine = planData?.data?.lineLevelPlans?.lines?.[0];
  const selectedLLP = selectedPlan?.planId;
  const availablePerks = selectedLine?.availablePerks || [];
  const products = selectedLine?.products || [];
  const planInfo = products?.[0]?.plans?.find((plan) => plan?.planId === selectedLLP) || {};
  const availablePromos = Array.isArray(selectedLine?.availablePromos)
    ? selectedLine.availablePromos : [];
  const matchingAvailablePromo = availablePromos.find((promo) => promo?.spoId === perkId);
  const fulfillmentCode = (matchingAvailablePromo?.dynamicAttrList || [])
    .find((attribute) => {
      const attrId = attribute?.attrId || '';
      return attrId.toLowerCase() === 'fulfillmentcode';
    })?.value;
  const matchingPromoId = perkId || matchingAvailablePromo?.spoId;
  const isGooglePromoDefectFixesEnabled = googlePromoDefectFixesFFlag();
  const promotions = getFilteredPromotions(isGooglePromoDefectFixesEnabled,planInfo, matchingPromoId, fulfillmentCode);
  let filteredPromotions = (
    promotions?.length
      ? promotions
      : planInfo?.promotions?.filter((promo) => promo?.promoType === 'PERK' && promo?.spoId?.split(',')?.includes(perkId))
  ) || [];

  if (!filteredPromotions.length || !availablePerks?.some((perk) => perk?.spoId === perkId)) {
    return null;
  }
  if (isGooglePromoDefectFixesEnabled) {
    filteredPromotions = filteredPromotions?.filter(
      (promo) =>
        promo?.promoType === 'PERK' &&
        promo?.spoId?.split(',')?.includes(perkId) &&
        Array.isArray(promo?.badgeMessages) &&
        promo.badgeMessages.length > 0
    );
  }
  const perkPromo = filteredPromotions.reduce((min, promo) => {
    if (promo.priority !== undefined && (min.priority === undefined || promo.priority < min.priority)) {
      return promo;
    }
    return min.priority === undefined ? promo : min;
  }, {});

  const perkEyeBrowBadgeMsg = perkPromo?.badgeMessages?.find((message) => message.placement === placement);

  if (perkEyeBrowBadgeMsg) {
    return {...perkEyeBrowBadgeMsg, choiceOffer: perkPromo?.choiceOffer};
  }

  return null;
};

export const prefetchConditions = () => getAPPID() === 'NSE' && !isSequentialFlow() && isSelfSetupSelected() && !isJointTransactionFlow();

export const isEditFlowPrefetch = () => {
  const keysToCheck = ['isPopularPlanEdit', 'isPlansEdit', 'isSetupEdit', 'isPerksEdit'];
  return keysToCheck.every((key) => getSession(key) !== 'Y');
};
export const  isCpHeadSpin = () => {
  const userAgent = window.navigator.userAgent.toLowerCase();
  return userAgent.includes('headspin') || userAgent.includes('catchpoint');
};

export const handleDeleteCartDispatch = (actionTypeValue, zipCodeValue) => {
  const pageNameValue = getPageName();
  store.dispatch({ type: actionTypeValue, pageName: pageNameValue, zipCode: zipCodeValue });
};


export const pageNamePayLoad = () => {
  const pageName = getPageName()
  let pageNameValue
  if (pageName === 'getStreamingDevices' || pageName === 'deviceSetup' || pageName === 'getCartDetails') {
    switch (pageName) {
      case "getStreamingDevices":
        pageNameValue = "addons"
        break;
      case "deviceSetup":
        pageNameValue = "setup"
        break;
      case "getCartDetails":
        pageNameValue = "cart"
        break;
      default:
        break;
    }
    return pageNameValue
  }
  return false
}


export const getTileWidth = () => isMobile() ? '140px' : '185px';


export const isStreamlineFlow = () => window.sessionStorage.getItem('widgetLQHost') === 'Streamline';

export const hasMostPopularPlansData = () => {
  const storeDetails = store?.getState();
  return storeDetails?.progressivePlans?.progressivePlanAPiResponse?.data?.lineLevelPlans?.lines?.[0]?.mostPopularPlans?.length > 0;
};

export const isVHILiteQualified = () => {
  const LQResponseData = getSession('LQResponse');
  return LQResponseData && JSON.parse(LQResponseData)?.output?.VHILiteQualified ? JSON.parse(LQResponseData)?.output?.VHILiteQualified : false;
};

export const isVHILiteFlow = () => isVHILiteQualified();

export const isVHILitePlanSelected = () => isVHILitePlan(store.getState()?.progressivePlans?.selectedPlanInfo?.selectedPlan?.planId) && isVHILiteQualified();

export const isVHILiteExtraPlanSelected = () => isVHILitePlusFFlag() && isVHILiteQualified();
export const isVHIExtraPlan = () => isVHILitePlusFFlag() && isVHILiteExtraPlan(store.getState()?.progressivePlans?.selectedPlanInfo?.selectedPlan?.planId) && isVHILiteQualified();

export const isVHILiteAllplansIncludeFFlag = () => {
  const featureFlags = store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.vhiLiteAllplansIncludeFFlag || false;
};

export const hideFreeProInstallText = () => {
  const LQResponseData = getSession('LQResponse');
  const bundleDetails = JSON.parse(LQResponseData)?.output?.bundleDetails;
  return !bundleDetails || !Array.isArray(bundleDetails) || bundleDetails.length === 0;
};

export const isVHILitePlusFFlag = () => {
  const featureFlags = store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.vhiLitePlusFFlag || false;
};

export const isVHILiteExtraLabelFFlag = () => {
  const featureFlags = store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.vhiLiteExtraLabelFFlag || false;
};

export const vhiLiteExtraDigitalHomeInternetFFlag = () => {
  const LQResponseData = getSession('LQResponse');
  return LQResponseData && JSON.parse(LQResponseData)?.output?.vhiLiteExtraDigitalHomeInternetFFlag ? JSON.parse(LQResponseData)?.output?.vhiLiteExtraDigitalHomeInternetFFlag : false;
};

export const isVhiLiteExtraDigitalHomeInternetFFlag = () => {
  const featureFlags = store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.vhiLiteExtraDigitalHomeInternetFFlag || false;
}

export const istgwAllPlansIncludeFFlag = () => {
 const featureFlags = store.getState()?.progressivePlans?.progressivePlanAPiResponse?.data?.featureFlags;
  return featureFlags?.tgwAllPlansIncludeFFlag || false;
}

export const getNotificationBannerPropsVF = (isVfny, props, setVfShowModal) => {
  const notificationProps = {
    renderIf: true,
    title: isVfny && props.notificationVfNyTitle ? props.notificationVfNyTitle : props?.notificationVfTitle,
    subtitle: '',
    type: 'success',
    hideCloseButton: false,
    serviceInfo: '',
    buttonData: [
      {
        children: 'Learn more',
        ariaLabel: `Learn more about ${isVfny ? props?.notificationVfNyTitle : props?.notificationVfTitle}`,
        onClick: () => {
          setVfShowModal(true);
        },
        'data-track': `{"type": "link",  "name": " learn more - vfwd-ny "}`,
      },
    ],
  };

  return notificationProps
}

export const ACPModalBody = styled.div`
  .description {
    margin-bottom: 24px;
  }
  .terms {
    font-size: 11px;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.5px;
  }
`;
export const getSandboxISPU = (showIspuUpfrontFFlag) => showIspuUpfrontFFlag ? 'ispu_y' : 'ispu_n';

export const getSandBoxISPUFFlag = (showIspuUpfrontFFlag) => showIspuUpfrontFFlag ? 'ispu_t' : 'ispu_f';

export const getDataTrackAddPerkEC = () => `{"type": "link","name":"add perk"}`;
  

export const checkTechRecommenderFlagProf = (fwaTechRecommenderCBandSOEDigitalFFlag, techRecommendation) =>
  fwaTechRecommenderCBandSOEDigitalFFlag && String(techRecommendation).toLowerCase() === HIGH;

export const checkTechRecommenderMmwVerbiageFlag = (fwaTechRecommenderMMWVerbiageFFlag, techRecommendation) =>
  fwaTechRecommenderMMWVerbiageFFlag && String(techRecommendation).toLowerCase() === HIGH;

export const checkTechRecommenderFlagCritical = (fwaTechRecommenderCBandDigitalCriticalFFlag, techRecommendation) =>
  fwaTechRecommenderCBandDigitalCriticalFFlag && String(techRecommendation).toLowerCase() === CRITICAL;

export const getTechRecommendationLQResponse = () => {
  const LQResponseData = getSession('LQResponse');
  const defaultReturn = {
    criticalLQResponse: false,
    highLQResponse: false,
  };

  if (!LQResponseData) {
    return defaultReturn;
  }

  try {
    const parsedData = JSON.parse(LQResponseData);
    const techRecommendation = parsedData?.output?.techRecommendation || null;
    const techRecommenderEnhancementFlag = parsedData?.output?.techRecommenderEnhancementFlag || false;

    if (!techRecommenderEnhancementFlag || !techRecommendation) {
      return defaultReturn;
    }

    const criticalLQResponse = String(techRecommendation).toLowerCase() === CRITICAL;
    const highLQResponse = String(techRecommendation).toLowerCase() === HIGH;

    return {
      criticalLQResponse,
      highLQResponse,
    };
  } catch (error) {
    console.error('Error parsing LQResponse data:', error);
    return defaultReturn;
  }
}

export const getPlansPageTitle = () => isStreamlineFlow() ? "Streamline Ordering" : "Progressive Plan"

export const getDynamicLoyaltyPrice = (loyaltyDiscountMessage, dynamicPriceFeatureFlag, amountOff, dynamicLoyaltyDiscountMessage) => {
  const positiveAmountOff = Math.abs(amountOff);
  const dynamicDiscountAvailable = positiveAmountOff && dynamicLoyaltyDiscountMessage;
  return dynamicDiscountAvailable ? dynamicLoyaltyDiscountMessage?.replace(DYNAMIC_DISCOUNT_VALUE, `$${positiveAmountOff}/mo`) : loyaltyDiscountMessage;
};

export const checkNotificationContentForStreamTv = (cartDetailsJson, thisRef) => {
  const cartDetailsJsonList = cartDetailsJson?.dueTodayList;
  const streamTvInCart = cartDetailsJsonList?.length > 0 && cartDetailsJsonList?.filter(({ productId }) => productId === STREAM_TV_PRODUCT_ID);

  if (streamTvInCart?.length > 0 && !isLoggedIn()) {
    const quantity = parseInt(streamTvInCart[0]?.quantity);
    const availableQty = streamTvInCart[0]?.inventory?.qtyAvailable;

    if (availableQty === 0) {
      thisRef.setState({ streamTvOutOfStock: true });
    } else if (quantity > availableQty) {
      thisRef.setState({ qtyNotAvailable: true, availableDeviceQty: availableQty });
    }
  }
}

export const fetchTitleBasedonFlag = (thisRef) => {
  const baseTitle = 'Stream TV device is unavailable.';
  const availableQty = thisRef.state.availableDeviceQty;
  return thisRef.state.qtyNotAvailable 
    ? `Only ${availableQty} Stream TV ${getStreamTVQuantityCheck(availableQty)} available in the stock.` 
    : baseTitle;
}

export const fetchSubtitleBasedonFlag = (thisRef) => {
  const baseSubTitle = 'Removing Stream TV device from your cart, since it is not available currently.' ;
  const { availableDeviceQty } = thisRef.state;
  return thisRef.state.qtyNotAvailable ? `At the moment, only ${availableDeviceQty} ${getStreamTVQuantityCheck(availableDeviceQty)} available in the stock.` : baseSubTitle;
}

export const renderBasedOnFlag = (thisRef) => !isLoggedIn() && (thisRef.state.qtyNotAvailable || thisRef.state.streamTvOutOfStock);

export const getStreamTVQuantityCheck = (qty) => `${qty > 1 ? 'devices are' : 'device is'}`;

export const isVHILitePlan = (planId) => planId === VHI_LITE_PLAN_ID;
export const isVHILiteExtraPlan = (planId) => planId === VHI_LITE_EXTRA_PLAN_ID;

export const getMoversCurrentPlanId = () => {
  const { moversReducer } = store.getState();
  return moversReducer?.moveServiceInfo?.oldPlanId?.toString();
}

export const isCurrentPlanVHILite = () => (isVHILitePlan(getMoversCurrentPlanId()) || 
  (vhiLiteExtraDigitalHomeInternetFFlag() && isVHILiteExtraPlan(getMoversCurrentPlanId()))) 

export const getPlanType = (type, bandWidth) => {
  if ((type === MOVERS_PLAN_TYPE.PREVIOUS && (isVHILitePlan(getMoversCurrentPlanId()) || isVHILiteExtraPlan(getMoversCurrentPlanId()))) ||
      (type === MOVERS_PLAN_TYPE.CURRENT && isVHILiteQualified())) {
    return VHI_LITE_PLAN_NAME;
  }
  return bandWidth;
}

export const giftCardOfferFFlagValue = () => getSession('giftCardOfferFFlag') === 'true' || false;

export const giftCardOfferAPI = () => getSession('giftCardOfferAPI') === 'true' || false;

/**
 * Redesign exclusion guard for plan selection.
 *
 * These flows have dedicated behavior, journey constraints, or feature dependencies
 * that are not fully supported in the redesign yet. Keep this as a centralized gate
 * so eligibility remains consistent across pages and future exclusions can be added
 * in one place.
 */
export const isExcludedFromRedesignFlow = () =>
  isWHWFlow() ||
  isTrupFlowActive() ||
  isMoversFlow();

export const isEnableFwaRedesignFFlag = () =>
  getCookie('planSelectionTestFWA') === 'treatmentA' && !isExcludedFromRedesignFlow();

const REDESIGN_ALLOWED_PAGES = ['addons', 'popularplan', 'progressiveplan'];

export const isRedesignFlow = (pageName) => {
  if (!isEnableFwaRedesignFFlag()) return false;
  if (!pageName) return true;
  return REDESIGN_ALLOWED_PAGES.includes(pageName.toLowerCase());
};

export const vpmplansAndFeatures = () => (window.location.href.indexOf('/plansandFeature/') > -1) || false;

export const miniCartBtnDataTrack = (btn, miniCartFooterEnabled) => {
  if (miniCartFooterEnabled) {
    return btn?.children ?? 'Continue';
  }
  return "Continue";
};

export const focusOnFirstError = (contactFromRefInfo) => {
  const contactFormSequence = ['firstName', 'lastName', 'email', 'contactNumber'];
  contactFromRefInfo.setFormFocus(contactFormSequence.find((ele) => contactFromRefInfo.formErrors[ele]));
  return null;
};

export const isContactFormDataEqual = (contactFormData, primaryUserInfo) => (
  contactFormData?.firstName?.toLowerCase() === primaryUserInfo?.firstName?.toLowerCase() &&
  contactFormData?.lastName?.toLowerCase() === primaryUserInfo?.lastName?.toLowerCase() &&
  contactFormData?.email?.toLowerCase() === primaryUserInfo?.emailId?.toLowerCase()
);

export const hasFormErrors = (contactFromRefInfo) => contactFromRefInfo && contactFromRefInfo.formErrors && Object.keys(contactFromRefInfo.formErrors)?.length > 0;
export const getUpdatedSandboxFloatingIcon = (giftCardOfferFFlag, giftCardOfferTaggingFFlag) => {
  const sandboxValue = window?.vzdl?.target?.sandbox || '';
  if (giftCardOfferFFlag && giftCardOfferTaggingFFlag) {
    return `${sandboxValue}|fir_y`;
  }
  return `${sandboxValue}|fir_n`;
};


export const zIndexCalFunc = (element) => {
  const Element = document.getElementById(element);
  if (Element) {
      const elementIndex = window?.getComputedStyle(Element).zIndex
      return Number(elementIndex) + 10;
  }
  return null;
}

export const getSandboxValueForFloatingIconOffer = (giftCardOfferFFlag, giftCardOfferTaggingFFlag, isUpsellOfferApplied) => {
  const sandboxValue = window.vzdl?.target?.sandbox || '';
  if(giftCardOfferFFlag && giftCardOfferTaggingFFlag && getSession('floatingIconApplyOfferClicked') === 'true'){
    return `${sandboxValue}|fir_y`
  } 
  if (!isUpsellOfferApplied) {
    return `${sandboxValue}|fir_n`;
  }

  return sandboxValue;
};

export const vpmConfirmationAPIUrl = () => {
  const nonprodvpmConfirmation= 'https://oa-uat.ebiz.verizon.com/iop/5gvpmorder/api/1.0.0/vendorportal/services/orderservice/savePPStatusToVPM';
  const prodvpmConfirmation= 'https://oa.verizon.com/iop/5gvpmorder/api/1.0.0/vendorportal/services/orderservice/savePPStatusToVPM';
  let apiUrl = nonprodvpmConfirmation;
    const hostName = window.location.href;
    if (hostName.indexOf('www.verizon.com') > 0) {
      apiUrl = prodvpmConfirmation;
    }
    return apiUrl
}

/**
 * @param {{ forceLoad?: boolean }} [options]
 *   When forceLoad is true (e.g. vzChatEnabled cookie), loads the bundle on all
 *   environments including production without requiring chatBot/voiceBot query params.
 */
export const loadVzGptChatbotScript = (options = {}) => {
  try {
    const { forceLoad = false } = options;
    const isProd = window.location.hostname === 'www.verizon.com';
    if (!forceLoad && isProd) return;
    const params = new URLSearchParams(window.location.search);
    const isChatBot = params.get('chatBot') === 'true';
    const cesVoiceBotParam = params.get('cesVoiceBot') === 'true';
    const isVoiceBot = params.get('voiceBot') === 'true' && cesVoiceBotParam;
    window.veradl = {};
    const pageName = getUrlName(window.location.pathname);
    const baseUrl = window.location.hostname === 'localhost' ? 'https://vzwqa1.verizonwireless.com' : window.location.origin;
    let vzGptUrl = `${baseUrl}/nextgendigital/sales/assistant/scripts/vzgpt-bundle.min.js`;
    if (isVoiceBot) {
      window.veradl = {
        voicebotEnabled: true,
        agentName: 'homebot',
        agentType: 'sales',
        initialMessage: 'Hello, I need help with my order',
        pageName,
        callback() {
          // Handle agent function calls here
        },
      };
      vzGptUrl = `${vzGptUrl}?voiceBotOnly=true`;
    }
    if (forceLoad || isChatBot || isVoiceBot) {
      loadjs(vzGptUrl, { returnPromise: true })
        .then((resp) => {
          console.log('success vz gpt script loaded...', resp);
        })
        .catch((err) => {
          console.log('error vz gpt script', err);
        });
    }
  } catch (e) {
    console.log('err vz gpt script', e);
  }
};

export const isCABBEligible = () => {
  const { cBandPlans, progressivePlans, cartDetails, checkout } = store.getState();
  const iscabbProgressivePlans =
    progressivePlans?.progressivePlanAPiResponse?.data?.acpInfo?.benefit &&
    progressivePlans?.progressivePlanAPiResponse?.data?.acpInfo?.benefit === 'CABB';
  const isCABBFromCart = cartDetails?.cartDetailsJson?.acpInfoDetails?.benefit && cartDetails?.cartDetailsJson?.acpInfoDetails?.benefit === 'CABB';
  const isCABBFromcBandPlans = cBandPlans?.plans?.output?.acpInfo?.benefit && cBandPlans.plans?.output?.acpInfo?.benefit === 'CABB';
  const isCABBFromCheckout = checkout?.cart?.acpInfo?.benefit && checkout?.cart?.acpInfo?.benefit === 'CABB';

  return isCABBFromcBandPlans || iscabbProgressivePlans || isCABBFromCart || isCABBFromCheckout;
};

export const isVFCABBEligible = () => {
  const { cBandPlans, progressivePlans, cartDetails, checkout } = store.getState();
  const isvfcabbProgressivePlans =
    progressivePlans?.progressivePlanAPiResponse?.data?.acpInfo?.benefit &&
    progressivePlans?.progressivePlanAPiResponse?.data?.acpInfo?.benefit === 'VFCAB';
  const isvfcabbFromCart = cartDetails?.cartDetailsJson?.acpInfoDetails?.benefit && cartDetails?.cartDetailsJson?.acpInfoDetails?.benefit === 'VFCAB';
  const isvfcabbFromcBandPlans = cBandPlans?.plans?.output?.acpInfo?.benefit && cBandPlans.plans?.output?.acpInfo?.benefit === 'VFCAB';
  const isvfcabbFromCheckout = checkout?.cart?.acpInfo?.benefit && checkout?.cart?.acpInfo?.benefit === 'VFCAB';

  return isvfcabbFromcBandPlans || isvfcabbProgressivePlans || isvfcabbFromCart || isvfcabbFromCheckout;
};

export const getNotificationBannerPropsCABB = (props, setShowCABBModal) => {
  const notificationProps = {
    renderIf: true,
    title: props?.notificationCABBTitle,
    subtitle: '',
    type: 'success',
    hideCloseButton: false,
    serviceInfo: '',
    buttonData: [
      {
        children: 'Learn more',
        ariaLabel: `Learn more about ${props?.notificationCABBTitle}`,
        onClick: () => {
          setShowCABBModal(true);
        },
        'data-track': `{"type": "link",  "name": " learn more - cabb "}`,
      },
    ],
  };

  return notificationProps
}

export const getNotificationBannerPropsVfCabb = (props, setShowVfcabbModal) => {
  const notificationProps = {
    renderIf: true,
    title: props?.notificationVfCabbTitle,
    subtitle: '',
    type: 'success',
    hideCloseButton: false,
    serviceInfo: '',
    buttonData: [
      {
        children: 'Learn more',
        ariaLabel: `Learn more about ${props?.notificationVfCabbTitle}`,
        onClick: () => {
          setShowVfcabbModal(true);
        },
        'data-track': `{"type": "link",  "name": " learn more - vfcab "}`,
      },
    ],
  };

  return notificationProps
}

export { isIOSNewVersion };
